<template>
	<div id="clickOutside"></div>
	<div class="flex flex-col gap-2">
		<div class="flex items-center justify-between w-full gap-2">
			<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '')"
				>{{ tabName + " - " + subTabName }}
			</PageLabel>

			<div class="flex flex-row items-center gap-2">
				<Button id="btnback" v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)" @click.stop="changePage('prev')"> Back </Button>
				<!-- :disabled="actualRawMaterialId === null"  ss <Button id="btnSaveGeneralInformation" class="btn p-button" @click.prevent="cioaico" :disabled="progressSaving == true">sdsdsdsdds</Button> -->
				<Button
					id="btnSaveGeneralInformation"
					@click="saveRawMaterials(true)"
					:disabled="progressSaving == true"
					v-bind="lock.button.value"
					v-tooltip="lock.tooltip"
					>Save</Button
				>
				<Button
					id="btnNext"
					v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
					:disabled="
						actualRawMaterialId === undefined || actualRawMaterialId === null || (rawMaterialEntries ? rawMaterialEntries.length === 0 : false)
					"
					@click.stop="changePage('next')"
				>
					Next
				</Button>
			</div>
		</div>
		<div class="flex" v-if="props.tabName !== tabsDefinitions.packaging.value && props.tabName !== tabsDefinitions.distribution.value">
			<h2>{{ (stepNumber ?? "") + " - " + stepName }}</h2>
		</div>
		<div class="flex flex-col" v-if="props.tabName === tabsDefinitions.distribution.value">
			<I2FormRow>
				<I2FormField label="Total drug product mass per pallet">{{ distTotalDrugProdMass }}</I2FormField>
			</I2FormRow>
			<I2FormRow>
				<I2FormField label="Total mass of Pallet">{{ distTotalMassOfPallet }} </I2FormField>
			</I2FormRow>
			<I2FormRow>
				<I2FormField label="Total mass including downstream packaging and containers">
					{{
						distTotalMassIncludingDownstream
							? distTotalMassIncludingDownstream.toFixed(2)
							: distTotalMassOfPallet
								? distTotalMassOfPallet.toString().replace(/kg/gi, "").trim()
								: "0.00"
					}}
					kg
				</I2FormField>
			</I2FormRow>
		</div>
		<div class="flex items-center justify-between w-full gap-2">
			<div :class="'grid ' + (props.tabName === tabsDefinitions.productProcess.value ? 'grid-cols-1 ' : 'grid-cols-2 ') + 'gap-2 w-full'">
				<div class="flex flex-col gap-4" v-if="props.tabName === tabsDefinitions.biologics.value">
					<I2FormRow>
						<I2FormField label="Bulk Drug Substance (Dry Weight) Mass Output of Step">{{ proteinMassOutput }} {{ proteinMOUnit }}</I2FormField>
					</I2FormRow>
					<I2FormRow>
						<I2FormField label="Concentration of BDS in production bioreactor output"
							>{{ concProteinMassProdOutput }} {{ concentrationUnit }}
						</I2FormField>
					</I2FormRow>
					<I2FormRow>
						<I2FormField label="Site Location"> {{ siteLocationName }} </I2FormField>
					</I2FormRow>
				</div>
				<div class="flex flex-col gap-2" v-if="props.tabName === tabsDefinitions.packaging.value">
					<I2FormRow v-if="props.subTabName === subTabsDefinitions.deviceMaterials.value.label">
						<I2FormField label="Lifetime Reference Units per Device">{{ lifeTimeRef }} {{ lifeTimeRefUnit }} </I2FormField>
					</I2FormRow>
				</div>
				<div class="flex flex-col gap-2">
					<I2FormRow v-if="props.tabName !== tabsDefinitions.packaging.value && props.tabName !== tabsDefinitions.distribution.value">
						<I2FormField label="Notes">
							<Textarea
								v-model="notes"
								placeholder="Please enter notes"
								rows="4"
								@change="changeBasicInfo"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/>
						</I2FormField>
					</I2FormRow>
					<I2FormRow v-if="props.tabName === tabsDefinitions.productProcess.value">
						<I2FormField label="Process Step Output Name">
							<InputText
								v-model="productOutputName"
								placeholder="Please enter product output name"
								@change="changeBasicInfo"
								:class="{
									'p-invalid': saveAttempted && !productOutputName,
									'': productOutputName !== undefined,
								}"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/>
						</I2FormField>
					</I2FormRow>
					<I2FormRow v-if="props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value">
						<I2FormField label="Mass of Process Step Output">
							<InputText
								v-model="massOutput"
								@keypress="onlyNumbers($event)"
								:class="{
									'p-invalid': (saveAttempted && massOutput == null) || massOutput == '',
									'': massOutput !== null,
								}"
								@change="changeBasicInfo"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/>
						</I2FormField>
						<I2FormField label="Unit">
							<Select
								v-model="selectedUnit"
								:options="groupedWeightAndVolumeUnits"
								optionGroupLabel="label"
								optionGroupChildren="items"
								optionLabel="unitName"
								option-value="id"
								placeholder="Select unit"
								:class="{
									'p-invalid': saveAttempted && selectedUnit == null,
									'': selectedUnit !== null,
								}"
								@change="changeBasicInfo"
								v-bind="lock.select.value"
								v-tooltip="lock.tooltip"
							>
							</Select>
						</I2FormField>
					</I2FormRow>
					<I2FormRow v-if="props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value">
						<I2FormField label="Site Location">
							<Select
								v-model="selectedSite"
								:options="siteLocations"
								optionLabel="siteLocationName"
								option-value="id"
								placeholder="Select Location"
								:class="{
									'p-invalid': saveAttempted && selectedSite == null,
									'': selectedSite !== null,
								}"
								filter
								@change="changeBasicInfo"
								v-bind="lock.select.value"
								v-tooltip="lock.tooltip"
							>
							</Select>
						</I2FormField>
					</I2FormRow>
					<!-- <I2FormRow> -->
					<I2FormRow v-if="props.tabName === tabsDefinitions.syntheticAPI.value">
						<I2FormField label="Unit Operations" v-if="!addNewUnitOperation">
							<MultiSelect
								v-model="selectedUnitOperations"
								:options="unitOperations"
								optionLabel="unitOperationName"
								option-value="id"
								display="chip"
								placeholder="Select Unit Operation"
								@change="updateFilteringOfUnitOperations"
								selectedItemsOrder="order"
								@contextmenu.prevent="onRightClick($event)"
								v-bind="lock.multiSelect.value"
								v-tooltip="lock.toolTipTargetRoot.value"
							>
							</MultiSelect>
							<ContextMenu :model="menuItems" ref="menu" />
						</I2FormField>

						<I2FormField label="New Unit Operation Name" v-if="addNewUnitOperation">
							<InputText v-model="unitOperation.unitOperationName" v-bind="lock.input.value" v-tooltip="lock.tooltip" /> </I2FormField
					></I2FormRow>
					<I2FormRow v-if="props.tabName === tabsDefinitions.syntheticAPI.value && showUnitOperationWarning">
						<warningBlock :warningMessages="unitOperationWarningMessages" />
					</I2FormRow>
					<I2FormRow>
						<I2FormField label="Electricity (kWh/hr/m2)" v-if="addNewUnitOperation">
							<InputText
								v-model="unitOperation.electricity"
								@keypress="onlyNumbers($event)"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/> </I2FormField
						><I2FormField label="Steam (kWh/hr/m2)" v-if="addNewUnitOperation">
							<InputText
								v-model="unitOperation.steam"
								@keypress="onlyNumbers($event)"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/> </I2FormField
						><I2FormField label="Loss (kWh/hr/m2)" v-if="addNewUnitOperation && displayLoss">
							<InputText
								v-model="unitOperation.loss"
								@keypress="onlyNumbers($event)"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/> </I2FormField
					></I2FormRow>
					<I2FormRow>
						<I2FormField label="Comment" v-if="addNewUnitOperation">
							<Textarea
								v-model="unitOperation.comment"
								placeholder="Please enter comment"
								rows="2"
								v-bind="lock.textarea.value"
								v-tooltip="lock.tooltip"
							/>
						</I2FormField>
					</I2FormRow>
					<I2FormRow v-if="false">
						<Button
							id="btnAddUnitOp"
							v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && !addNewUnitOperation"
							@click="addNewUnitOp"
							v-bind="lock.button.value"
							v-tooltip="lock.tooltip"
						>
							Add new Unit Operation
						</Button>
						<Button
							id="btnSaveUnitOp"
							v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && addNewUnitOperation"
							@click="saveNewUnitOp"
							v-bind="lock.button.value"
							v-tooltip="lock.tooltip"
						>
							Save
						</Button>
						<Button
							id="btncancel"
							v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && addNewUnitOperation"
							@click="cancelNewUnitOp"
						>
							Cancel
						</Button>
					</I2FormRow>
				</div>
				<div v-if="props.tabName === tabsDefinitions.syntheticAPI.value">
					<FileUpload
						name="rawMaterialImage"
						:multiple="false"
						accept="image/*"
						:maxFileSize="1000000"
						@select="onSelectedFiles"
						ref="fileUploader"
						mode="advanced"
						data:ima
					>
						<template #header>
							<Button
								:severity="'danger'"
								id="btnClearImage"
								v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
								@click="deleteImage"
								class="btn-tiny"
								v-bind="lock.button.value"
								v-tooltip="lock.tooltip"
							>
								Remove Image
							</Button>
							<div v-else></div
						></template>
						<template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
							<div v-if="actualFile === null && image === ''">
								<div class="flex align-items-center justify-content-center flex-column" style="height: 300px">
									<span style="cursor: pointer"
										><FontAwesomeIcon
											:icon="['far', 'cloud-upload']"
											title="Upload Image"
											@click="!assessmentStore.isLocked && openFileSelector()"
											class="flex align-items-center justify-content-center fa-10x"
											v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
											v-tooltip="lock.tooltip"
									/></span>

									<p class=" ">Drag and drop files or click here to upload.</p>
								</div>
							</div>
							<div v-else-if="image !== '' && image !== undefined">
								<Image
									:src="`data:image/png;base64,${image}`"
									alt="Image2"
									@click.stop="!assessmentStore.isLocked && openFileSelector()"
									@change="changeBasicInfo"
									v-tooltip="lock.tooltip"
								/>
							</div>
							<div v-else-if="actualFile !== null && actualFile !== undefined">
								<div class="flex flex-wrap p-0 sm:p-0 gap-5">
									<Image
										:src="actualFile.objectURL"
										alt="Image1"
										@click.stop="!assessmentStore.isLocked && openFileSelector()"
										@change="changeBasicInfo"
										v-tooltip="lock.tooltip"
									/>
								</div>
							</div>
						</template>
					</FileUpload>
				</div>
			</div>
		</div>
		<div
			v-if="
				actualRawMaterialId === null &&
				props.tabName !== tabsDefinitions.packaging.value &&
				props.tabName !== tabsDefinitions.biologics.value &&
				props.tabName !== tabsDefinitions.distribution.value
			"
		>
			complete all field(s) above and click save
		</div>
		<div v-if="actualRawMaterialId !== null">
			<div class="flex items-center justify-between w-full gap-2">
				<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'Material'"> Materials</PageLabel>

				<warningBlock v-if="showVolumeWarning" :warningMessages="volumeWarningMessages" />

				<div class="flex flex-row items-center gap-2">
					<!-- <Button
					class="btn p-button inverted"
					id="btntableviewcompact"
					v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && progressSaving === false"
					@click="compactViewMaterialsTableNow()"
					>{{ compactViewMaterialsTable ? "Expand View" : "Compact View" }}</Button
				> -->
					<Button
						id="btntableviewcompact"
						v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && progressSaving === false"
						@click="saveRawMaterialList(true, true)"
						v-bind="lock.button.value"
						v-tooltip="lock.tooltip"
					>
						Save
					</Button>
					<Button
						id="btntableviewcompact"
						v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && progressSaving === false"
						@click="compactViewMaterialsTableNow()"
						>{{ compactViewMaterialsTable ? "Expand View" : "Compact View" }}</Button
					>
				</div>
			</div>
			<div>
				<DataTable
					:value="rawMaterialEntries"
					responsiveLayout="scroll"
					:row-hover="true"
					:paginator="true"
					:scrollable="false"
					:totalRecords="rawMaterialEntries.length"
					:rows="tablePaginator == null ? 10 : tablePaginator.rows"
					v-model:first="firstRowOfPage"
					:page="tablePaginator == null ? 0 : tablePaginator.page"
					@page="pageChanged($event)"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10, 20, 50]"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
					dataKey="id"
					filterDisplay="menu"
					:loading="loading1"
					:globalFilterFields="['materialName']"
					:id="'dtRawMaterialList_' + props.tabId"
					tableStyle="min-width: 50rem"
					:disabled="addNewUnitOperation"
					v-model:selection="selectedRow"
					@update:rows="checkNumberOfEntriesThenMoveNextPage"
					ref="materialTableRef"
					selectioMode="single"
				>
					<template #footer>
						<span style="cursor: pointer" @click="addMaterial(1)" v-if="!enableFilterOnMaterial"
							><FontAwesomeIcon
								:icon="['far', 'plus-circle']"
								title="Add one Material"
								class="ml-2"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
								v-bind="lock.button.value"
								v-tooltip="lock.tooltip"
							/><span class="ml-2">Add Material</span></span
						>
						<span style="cursor: pointer" @click="!assessmentStore.isLocked && addMaterialByFilter()"
							><FontAwesomeIcon
								:icon="['far', 'plus-circle']"
								title="Add one Material"
								class="ml-2"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
							/><span class="ml-2">Add Material</span></span
						>
						<span style="cursor: pointer" @click="!assessmentStore.isLocked && addMaterial(5)" v-if="!enableFilterOnMaterial"
							><FontAwesomeIcon
								:icon="['far', 'plus-circle']"
								title="Add 5 Materials"
								class="ml-4"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
							/><span class="ml-2">Add 5 Materials</span></span
						>
					</template>

					<template #empty> No materials found. </template>
					<template #loading>
						<div style="text-align: center; padding: 1rem">
							<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 ml-2" spin />
							<p style="color: white !important">Loading data, please wait...</p>
						</div>
					</template>
					<Column
						field="componentName"
						filterField="componentName"
						header="Component Name"
						style="flex: 0 0 10%"
						v-if="props.tabName === tabsDefinitions.packaging.value"
					>
						<template #body="{ data, index }">
							<InputText
								v-model="data.componentName"
								@change="changeMaterial('componentName', $event, data)"
								style="width: 180px"
								:class="{
									'p-invalid': props.tabName === tabsDefinitions.packaging.value && data.componentName == null,
									'': data.componentName !== null,
								}"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/>
						</template>
					</Column>
					<Column
						field="materialCategory"
						filterField="materialCategory"
						:header="
							'Material ' +
							(props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value ? 'Type' : 'Category')
						"
						style="flex: 0 0 15%"
					>
						<template #body="{ data, index }">
							<div v-if="enableFilterOnMaterial">
								{{
									($props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value) &&
									data.materialSubTypeName
										? data.materialSubTypeName
										: data.materialTypeName
								}}
							</div>
							<div v-else>
								<Select
									v-if="$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value"
									v-model="data.materialSubTypeId"
									:options="
										$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
											? subTabsDefinitions.deviceMaterials.value.label === props.subTabName
												? materialSubTypes.filter((item: any) => item.materialSubTypeName !== 'Pallet')
												: materialSubTypes
											: materialTypes
									"
									:optionLabel="
										$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
											? 'materialSubTypeName'
											: 'materialTypeName'
									"
									option-value="id"
									:placeholder="
										'Select ' +
										(props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value ? 'Type' : 'Category')
									"
									class="w-full md:w-14rem"
									@change="
										changeMaterial(
											$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
												? 'materialSubType'
												: 'materialType',
											$event,
											data
										)
									"
									filter
									:class="{
										'p-invalid':
											$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
												? data.materialSubTypeId === undefined
												: data.materialTypeId === null,
										'':
											$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
												? data.materialSubTypeId !== undefined
												: data.materialTypeId !== null,
									}"
									v-bind="lock.select.value"
									v-tooltip="lock.tooltip"
								>
								</Select>

								<Select
									v-else
									v-model="data.materialTypeId"
									:options="
										$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
											? materialSubTypes
											: materialTypes
									"
									:optionLabel="
										$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
											? 'materialSubTypeName'
											: 'materialTypeName'
									"
									option-value="id"
									placeholder="Select Type"
									class="w-full md:w-14rem"
									@change="
										changeMaterial(
											$props.tabName === tabsDefinitions.packaging.value || $props.tabName === tabsDefinitions.distribution.value
												? 'materialSubType'
												: 'materialType',
											$event,
											data
										)
									"
									filter
									:class="{
										'p-invalid': data.materialTypeId === null,
										'': data.materialTypeId !== null,
									}"
									v-bind="lock.select.value"
									v-tooltip="lock.tooltip"
								>
								</Select>
							</div>
						</template>
					</Column>
					<Column field="material" filterField="material" header="Material" style="flex: 0 0 30%">
						<template #body="{ data, index }">
							<div v-if="enableFilterOnMaterial">
								<div
									class="flex items-center gap-2"
									@click="!assessmentStore.isLocked && changeMaterialWithDialog(data, index)"
									v-if="props.tabName === tabsDefinitions.productProcess.value && data.isIntermediate"
								>
									<span v-tooltip="assessmentStore.isLocked ? lock.tooltip : `Click to replace material`">{{
										getMaterialName(data) ? getMaterialName(data) : data.materialName
									}}</span>
									<FontAwesomeIcon :icon="['far', 'flask']" v-show="data.isProxy" />
								</div>
								<!-- <div class="flex items-center gap-2" @click="changeMaterialWithDialog(data, index)" v-else>
							{{ data.materialName }}
							<FontAwesomeIcon :icon="['far', 'flask']" v-show="data.isProxy" />
							<span v-tooltip.top="getToolTipForAPIProxy(data)"><FontAwesomeIcon :icon="['far', 'flask']" v-show="data.isAPIProxy" /></span>
						</div> -->
								<div class="flex items-center gap-2" @click="!assessmentStore.isLocked && changeMaterialWithDialog(data, index)" v-else>
									<span
										v-show="!data.isSourceMaterialActive"
										v-tooltip="
											assessmentStore.isLocked
												? lock.tooltip
												: 'Material has been removed from the database, it will still work for this assessment but will not be available for new assessments.'
										"
									>
										<FontAwesomeIcon :icon="['far', 'trash-xmark']"
									/></span>
									<span v-tooltip="assessmentStore.isLocked ? lock.tooltip : `Click to replace material`">{{ data.materialName }}</span>

									<FontAwesomeIcon :icon="['far', 'flask']" v-show="data.isProxy" />

									<span @mouseenter="showOverlay($event, data)"> <FontAwesomeIcon :icon="['far', 'flask']" v-show="data.isAPIProxy" /></span>
								</div>
							</div>
							<div v-else>
								<div class="flex items-center gap-2">
									<Select
										v-model="data.materialId"
										:options="data.materials"
										optionLabel="materialName"
										option-value="id"
										placeholder="Select Material"
										class="w-full md:w-14rem"
										@change="changeMaterial('materialName', $event, data)"
										filter
										:class="{ 'p-invalid': data.materialId === null, '': data.materialId !== null }"
										v-bind="lock.select.value"
										v-tooltip="lock.tooltip"
									>
									</Select>
									<FontAwesomeIcon :icon="['far', 'flask']" v-show="data.isAPIProxy || data.isProxy" />
								</div>
							</div>
						</template>
					</Column>
					<Column
						field="cas"
						filterField="cas"
						header="CAS"
						style="flex: 0 0 5%"
						v-if="props.tabName !== tabsDefinitions.packaging.value && props.tabName !== tabsDefinitions.distribution.value"
					>
						<template #body="{ data, index }">
							<div v-if="enableFilterOnMaterial">
								{{ data.materialTypeName === "Intermediates" ? "-" : data.cas }}
							</div>
							<div v-else>
								<div v-if="data.materialTypeName === 'Intermediates'">-</div>
								<div v-else>
									<Select
										v-model="data.materialId"
										:options="materials.filter((item: any) => item.cas !== '' && item.cas !== null)"
										optionLabel="cas"
										option-value="id"
										placeholder="Select CAS"
										class="w-full md:w-14rem"
										@change="changeMaterial('cas', $event, data)"
										filter
										:filter-fields="['cas', 'materialName']"
										filter-match-mode="contains"
										:class="{
											'p-invalid': saveAttempted && data.materialId === null,
											'': data.materialId !== null,
										}"
										v-bind="lock.select.value"
										v-tooltip="lock.tooltip"
									>
										<template #option="data">
											<div class="flex align-items-center">
												<div>{{ data.option.cas }} - {{ data.option.materialName }} [{{ data.option.materialType.materialTypeName }}]</div>
											</div>
										</template>
									</Select>
								</div>
							</div>
						</template>
					</Column>
					<Column
						field="quantity"
						filterField="quantity"
						:header="
							tabsDefinitions.distribution.value === props.tabName
								? 'Quantity per Pallet'
								: tabsDefinitions.packaging.value === props.tabName
									? 'Quantity Per Component'
									: 'Quantity'
						"
						style="flex: 0 0 10%"
					>
						<template #body="{ data, index }">
							<InputText
								v-model.number="data.quantity"
								@change="changeMaterial('quantity', $event, data)"
								@keypress="onlyNumbers($event)"
								:class="{
									'p-invalid': data.quantity === 0 || data.quantity === null || data.quantity === '',
									'': data.quantity !== 0 || data.quantity !== null || data.quantity !== '',
								}"
								style="width: 80px"
								:id="'quantityInput_' + data.id"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/>
						</template>
					</Column>
					<Column field="unit" filterField="unit" header="Unit" style="flex: 0 0 10%">
						<template #body="{ data, index }">
							<div class="flex items-center gap-2">
								<Select
									v-model="data.unitId"
									:options="
										(props.tabName !== tabsDefinitions.distribution.value && data.materialTypeName === 'Consumables') ||
										(props.tabName === tabsDefinitions.distribution.value && data.materialSubTypeName !== 'Others')
											? groupedConsumableUnits
											: groupedWeightAndVolumeUnits
									"
									optionLabel="unitName"
									optionGroupLabel="label"
									optionGroupChildren="items"
									option-value="id"
									placeholder="Select Unit"
									class="w-full md:w-14rem"
									@change="changeMaterial('unit', $event, data)"
									:class="{
										'p-invalid':
											((props.tabName === tabsDefinitions.packaging.value &&
												props.subTabName === subTabsDefinitions.packagingMaterials.value.label) ||
												props.tabName === tabsDefinitions.distribution.value ||
												props.tabName === tabsDefinitions.packaging.value ||
												props.tabName === tabsDefinitions.productProcess.value ||
												props.tabName === tabsDefinitions.biologics.value ||
												props.tabName === tabsDefinitions.syntheticAPI.value) &&
											data.unitId === null,
										'':
											((props.tabName === tabsDefinitions.packaging.value &&
												props.subTabName === subTabsDefinitions.packagingMaterials.value.label) ||
												props.tabName === tabsDefinitions.distribution.value) &&
											data.unitId !== null,
									}"
									v-bind="lock.select.value"
									v-tooltip="lock.tooltip"
								>
								</Select>

								<span
									v-if="isVolumeUnitWithMissingDensity(data)"
									class="ml-2 cursor-pointer"
									@click="enableRequestDensity ? showDensityDialog(data) : null"
								>
									<WarningIcon errorType="Warning" :tooltipText="[materialDensityToolTip]" />
								</span>
							</div>
						</template>
					</Column>
					<Column
						field="packagingType"
						filterField="packagingType"
						header="Packaging Type"
						style="flex: 0 0 10%"
						v-if="props.tabName === tabsDefinitions.packaging.value && props.subTabName === subTabsDefinitions.packagingMaterials.value.label"
					>
						<template #body="{ data, index }">
							<Select
								v-model="data.packagingTypeId"
								:options="packagingTypes"
								optionLabel="valueTxt"
								option-value="id"
								placeholder="Select Pack Type"
								class="w-full md:w-14rem"
								@change="changeMaterial('packagingType', $event, data)"
								:class="{
									'p-invalid':
										props.tabName === tabsDefinitions.packaging.value &&
										props.subTabName === subTabsDefinitions.packagingMaterials.value.label &&
										data.packagingTypeId === undefined,
									'':
										props.tabName === tabsDefinitions.packaging.value &&
										props.subTabName === subTabsDefinitions.packagingMaterials.value.label &&
										data.packagingTypeId !== undefined,
								}"
								v-bind="lock.select.value"
								v-tooltip="lock.tooltip"
							>
							</Select>
						</template>
					</Column>
					<Column
						field="unitOperations"
						filterField="unitOperations"
						header="Unit Operations"
						style="flex: 0 0 15%"
						v-if="shouldShowUnitOperationColumn"
					>
						<template #body="{ data, index }">
							<Select
								v-model="data.unitOperationId"
								:options="selectableUnitOperations"
								optionLabel="unitOperationName"
								option-value="id"
								placeholder="Select Unit Operation"
								class="w-full md:w-14rem"
								:class="{
									'p-invalid': isUnitOperationRequired && !data.unitOperationId,
									'': !isUnitOperationRequired || data.unitOperationId !== null,
								}"
								@change="changeMaterial('unitOperation', $event, data)"
								v-bind="lock.select.value"
								v-tooltip="lock.tooltip"
							>
							</Select>
						</template>
					</Column>
					<Column
						field="referenceQuantity"
						filterField="referenceQuantity"
						header="Reference Quantity"
						style="flex: 0 0 5%"
						v-if="props.tabName === tabsDefinitions.packaging.value"
					>
						<template #body="{ data, index }">
							<div v-if="subTabsDefinitions.deviceMaterials.value.label === props.subTabName">
								{{ lifeTimeRef }}
							</div>
							<div v-else>{{ data.referenceQuantity }}</div>
						</template>
					</Column>
					<Column field="carbonFootprint" filterField="carbonFootprint" header="Carbon Footprint (kg CO2e)" style="flex: 0 0 5%">
						<template #body="{ data }">
							<WarningIcon
								v-if="shouldShowRedXForMissingDensity(data)"
								errorType="Error"
								:tooltipText="['Cannot calculate carbon footprint due to missing density value.']"
							/>
							<span v-else>{{
								isNaN(data.carbonFootprint) ? "" : data.carbonFootprint !== null ? uiNumberFormatterAZ(data.carbonFootprint) : ""
							}}</span>
						</template>
					</Column>
					<Column field="dataQualityScore" filterField="dataQualityScore" header="Data Quality Rating" style="flex: 0 0 5%">
						<template #body="{ data }">
							<div v-if="data.materialTypeName === 'Intermediate'">-</div>
							<div v-else>
								<div class="w-full" v-tooltip.top="getDataQualityRatingTooltip(data.dataQualityScore)">
									<div :style="returnStyleDataQualityRatingColor(data.dataQualityScore)">
										<div class="p-d-flex p-jc-center">
											<b>{{ data.dataQualityScore }}</b>
										</div>
									</div>
								</div>
							</div>
						</template>
					</Column>
					<Column field="supplierName" filterField="supplierName" header="Supplier Name" style="flex: 0 0 30%" v-if="!compactViewMaterialsTable">
						<template #body="{ data, index }">
							<div v-if="data.materialTypeName === 'Intermediates'">-</div>
							<div v-else>
								<InputText
									v-model="data.supplierName"
									@change="changeMaterial('nothing', $event, data)"
									v-bind="lock.input.value"
									v-tooltip="lock.tooltip"
								/>
							</div>
						</template>
					</Column>
					<Column
						field="supplierLocation"
						filterField="supplierLocation"
						header="Supplier Location"
						style="flex: 0 0 30%"
						v-if="!compactViewMaterialsTable"
					>
						<template #body="{ data, index }">
							<div v-if="data.materialTypeName === 'Intermediates'">-</div>
							<div v-else>
								<InputText
									v-model="data.supplierLocation"
									@change="changeMaterial('nothing', $event, data)"
									v-bind="lock.input.value"
									v-tooltip="lock.tooltip"
								/>
							</div>
						</template>
					</Column>
					<Column field="notes" header="Notes" style="flex: 0 0 30%" v-if="!compactViewMaterialsTable">
						<template #body="{ data, index }">
							<InputText v-model="data.notes" @change="changeMaterial('nothing', $event, data)" v-bind="lock.input.value" v-tooltip="lock.tooltip" />
						</template>
					</Column>
					<Column field="id" header="Actions" style="width: 11%" styleClass="tdLessPadding">
						<template #body="{ data, index }"
							><span style="cursor: pointer"
								><FontAwesomeIcon
									:icon="['far', 'trash']"
									title="Delete"
									@click="!assessmentStore.isLocked && deleteMaterial(data, data.id)"
									class="ml-2"
									v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Delete)" /></span></template></Column
				></DataTable>
			</div>
			<div class="flex flex-row items-center gap-2">
				<!-- <Button 
				class="btn p-button inverted"
				id="btninbound"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				@click="showInboundTransport = !showInboundTransport"
				>{{ showInboundTransport ? "Hide" : "Show" }} Inbound Transport</Button
			> -->
				<Button
					class="btn btn-outline"
					id="btninbound"
					v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
					@click="showInboundTransport = !showInboundTransport"
					>{{ showInboundTransport ? "Hide" : "Show" }} Inbound Transport</Button
				>
			</div>
			<div v-if="showInboundTransport">
				<div class="flex items-center justify-between w-full gap-2">
					<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'InboundTransport'">
						Inbound Transport</PageLabel
					>

					<div class="flex flex-row items-center gap-2">
						<!-- <Button
						class="btn p-button inverted"
						id="btndefault"
						v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
						@click="applyDefaultTransportDialog()"
						>Apply Default Transport</Button
					> -->
						<Button
							id="btntableviewcompact"
							v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && progressSaving === false"
							@click="saveInboundTransportList(true, true)"
							v-bind="lock.button.value"
							v-tooltip="lock.tooltip"
						>
							Save
						</Button>
						<Button
							id="btndefault"
							v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
							@click="applyDefaultTransportDialog()"
							v-bind="lock.button.value"
							v-tooltip="lock.tooltip"
							>Apply Default Transport</Button
						>
					</div>
				</div>

				<Popover ref="op">
					<div @mouseleave="hideOverlay">
						<Tabs :value="0">
							<TabList>
								<Tab value="0">Details</Tab>
								<Tab value="1">Description</Tab>
							</TabList>
							<TabPanels>
								<TabPanel value="0">
									<p v-html="selectedRowForOverlay?.details"></p>
								</TabPanel>
								<TabPanel value="1">
									<p v-html="selectedRowForOverlay?.description"></p>
								</TabPanel>
							</TabPanels>
						</Tabs>
					</div>
				</Popover>

				<!-- Density Request Dialog -->
				<Dialog v-model:visible="showDensityDialogVisible" modal header="Request Density Information" style="width: 400px">
					<div class="flex flex-col gap-4">
						<p>Volume units are not available because this material does not have a density specified.</p>
						<p><strong>Material:</strong> {{ currentDensityRequestMaterial?.materialName }}</p>
						<p>Would you like to request that an administrator add the density information for this material?</p>
					</div>

					<template #footer>
						<Button label="Cancel" icon="pi pi-times" @click="showDensityDialogVisible = false" />
						<Button label="Request Density" icon="pi pi-check" @click="requestDensity" />
					</template>
				</Dialog>

				<div>
					<DataTable
						:value="inboundTransportList"
						responsiveLayout="scroll"
						:row-hover="true"
						:paginator="false"
						:rows="tablePaginator == null ? 10 : tablePaginator.rows"
						:first="tablePaginator == null ? 0 : tablePaginator.first"
						:page="tablePaginator == null ? 0 : tablePaginator.page"
						@page="pageChanged($event)"
						paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
						:rowsPerPageOptions="[10, 20, 50]"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
						dataKey="id"
						filterDisplay="menu"
						:loading="loading1"
						:globalFilterFields="['materialName']"
						id="dtAssessmentList"
						:disabled="addNewUnitOperation"
						v-readonly-lock
					>
						<template #loading>
							<div style="text-align: center; padding: 1rem">
								<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 ml-2" spin />
								<p style="color: white !important">Loading data, please wait...</p>
							</div>
						</template>
						<Column field="material" filterField="material" header="Material" style="flex: 0 0 30%">
							<template #body="{ data, index }">
								<span v-if="data.lastOne === true && data.modeOfTransportId !== null">
									<div class="w-full" @click="!assessmentStore.isLocked && addTransport(data, index)">
										<span style="cursor: pointer"
											><FontAwesomeIcon
												:icon="['far', 'plus-circle']"
												title="Add Transport Leg"
												class="ml-2"
												v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
											/><span class="ml-2">Add Transport Leg</span></span
										>
										<span v-html="data.materialName"> </span>
									</div>
								</span>
								<span v-else>
									<div class="w-full">
										<span v-html="'<b>' + data.materialName + '</b>'"> </span>
									</div>
								</span>
							</template> </Column
						><Column field="modeOfTransport" filterField="modeOfTransport" header="Mode of Transport" style="flex: 0 0 30%">
							<template #body="{ data, index }">
								<div v-if="!data.isTitle">
									<Select
										v-model="data.modeOfTransportId"
										:options="transports"
										optionLabel="transportName"
										option-value="id"
										filter
										placeholder="Select Transport"
										class="w-full md:w-14rem"
										@change="changeTransport('modeOfTransport', $event, index)"
										v-bind="lock.select.value"
										v-tooltip="lock.tooltip"
									>
									</Select>
									<!-- :class="{ 'p-invalid': data.modeOfTransportId === null, '': data.modeOfTransportId !== null }" -->
								</div>
							</template> </Column
						><Column field="distance" filterField="distance" header="Distance" style="flex: 0 0 30%">
							<template #body="{ data, index }">
								<div v-if="!data.isTitle">
									<InputText
										v-model.number="data.distance"
										@keypress="onlyNumbers($event)"
										:class="{
											'p-invalid': data.modeOfTransportId !== null ? data.distance === null || data.distance === 0 || data.distance === '' : false,
											'': data.distance !== null,
										}"
										@change="changeTransport('distance', $event, index)"
										v-bind="lock.input.value"
										v-tooltip="lock.tooltip"
									/>
								</div>
							</template> </Column
						><Column field="unit" filterField="unit" header="Unit" style="flex: 0 0 30%">
							<template #body="{ data, index }">
								<div v-if="!data.isTitle">
									<Select
										v-model="data.unitId"
										:options="groupedDistanceUnits"
										optionGroupLabel="label"
										optionGroupChildren="items"
										optionLabel="unitName"
										option-value="id"
										filter
										placeholder="Select Unit"
										class="w-full md:w-14rem"
										:class="{
											'p-invalid': data.modeOfTransportId !== null ? data.unitId === null : false,
											'': data.unitId !== null,
										}"
										@change="changeTransport('unit', $event, index)"
										v-bind="lock.select.value"
										v-tooltip="lock.tooltip"
									>
									</Select>
								</div>
							</template> </Column
						><Column field="id" header="Actions" style="width: 11%" styleClass="tdLessPadding">
							<template #body="{ data, index }"
								><span style="cursor: pointer" v-if="data.isTitle == false"
									><FontAwesomeIcon
										:icon="['far', 'trash']"
										title="Delete"
										@click="!assessmentStore.isLocked && removeAddedTransport(data, index)"
										class="ml-2"
										:disabled="!canDeleteInbound"
										v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Delete)" /></span></template></Column
					></DataTable>
				</div>
			</div>

			<div class="flex items-center justify-between w-full gap-2 2">
				<div></div>

				<div class="flex flex-row items-center gap-2">
					<Button
						id="btnbackBottom"
						v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
						:disabled="actualRawMaterialId === null"
						@click.stop="changePage('prev')"
						>Back</Button
					>
					<!-- <Button id="btnSaveGeneralInformation" class="btn p-button" @click.prevent="saveRawMaterials(true)" :disabled="progressSaving == true"
				>Save</Button
			> -->
					<Button
						id="btnSaveGeneralInformationBottom"
						@click.prevent="saveRawMaterials(true)"
						:disabled="progressSaving == true"
						v-bind="lock.button.value"
						v-tooltip="lock.tooltip"
						>Save</Button
					>
					<Button
						id="btnNextBottom"
						v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
						:disabled="
							actualRawMaterialId === undefined || actualRawMaterialId === null || (rawMaterialEntries ? rawMaterialEntries.length === 0 : false)
						"
						@click.stop="changePage('next')"
					>
						Next
					</Button>
				</div>
			</div>

			<!-- <div class="flex gap-2  ">
			<div style="width: 80%">&nbsp;</div>
			<div class="flex flex-row items-center gap-2">

				<Button
					class="btn btn-outline"
					id="btnback"
					v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
					:disabled="actualRawMaterialId === null"
					@click.stop="changePage('prev')"
					>Back</Button
				>

				<button id="btnSaveGeneralInformation" class="btn btn-primary" @click.prevent="saveRawMaterials(true)" :disabled="progressSaving == true">
					Save
				</button>
				<button
					class="btn btn-primary"
					id="btnNext"
					v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
					:disabled="actualRawMaterialId === null"
					@click.stop="changePage('next')"
				>
					Next
				</button>
			</div>
		</div> -->
		</div>
		<!-- <Toast :group="props.tabId" /> -->
		<Dialog :visible="dialogDefaultConfirmation" style="" modal :closable="false">
			<template #header>
				<h1>Apply default values?</h1>
			</template>
			<template #default>
				<div class="flex gap-2">
					<Button id="btnapply" severity="danger" @click="dialogDefaultConfirmation = false" class="flex-grow">No</Button>
					<Button
						id="btnSaveProject"
						class="btn btn-primary flex-grow"
						v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Create)"
						@click="applyDefaultTransport()"
					>
						Yes
					</Button>
				</div>
			</template>
		</Dialog>
		<Dialog v-model:visible="showDialogDelete" :modal="true" style="width: 35vw" :closable="false" contentStyle="overflow:visible">
			<template #header>
				<PageLabel :helpPageName="'materialDelete'">Delete Material </PageLabel>
			</template>
			<FormCard>
				<I2FormRow class="">
					<h1>Are you sure you would like to delete selected Material?</h1>
				</I2FormRow>
			</FormCard>
			<template #footer>
				<I2FormRow right>
					<Button label="Cancel" class="mr-4" @click="showDialogDelete = false" right />
					<Button label="Delete" class="ml-4" @click="deleteMaterialOK()" right />
				</I2FormRow>
			</template>
		</Dialog>
		<Dialog v-model:visible="showDialogDeleteTransport" :modal="true" style="width: 35vw" :closable="false" contentStyle="overflow:visible">
			<template #header>
				<PageLabel :helpPageName="'materialDelete'">Delete Transport </PageLabel>
			</template>
			<FormCard>
				<I2FormRow class="">
					<h1>Are you sure you would like to delete selected Transport?</h1>
				</I2FormRow>
			</FormCard>
			<template #footer>
				<I2FormRow right>
					<Button label="Cancel" class="mr-4" @click="showDialogDeleteTransport = false" right />
					<Button label="Delete" class="ml-4" @click="removeAddedTransportOK(dialogDeleteTransportMaterialRowId, dialogDeleteTransportIndex)" right />
				</I2FormRow>
			</template>
		</Dialog>
		<div v-if="showDialogMaterialSelection">
			<assessmentTabRawMaterialsSelectionDialog
				:stepId="actualStepId"
				:stepNumber="stepNumber"
				:screenId="props.tabId"
				:assessmentId="props.assessmentId"
				@selected="selectMaterial"
				@cancel="cancelRawMaterialsSelectionDialog"
				:selectableMaterials="selectableMaterials"
				:selectedMaterial="modMaterial || undefined"
			/>
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref, onMounted, reactive, watch, computed, nextTick, onUnmounted, watchEffect } from "vue"
import Textarea from "primevue/textarea"
import InputText from "primevue/inputtext"
import Image from "primevue/image"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Button from "primevue/button"
import Dialog from "primevue/dialog"
import Tooltip from "primevue/tooltip"

import Tabs from "primevue/tabs"
import TabList from "primevue/tablist"
import Tab from "primevue/tab"
import TabPanels from "primevue/tabpanels"
import TabPanel from "primevue/tabpanel"

import { SessionInfo, PageAccess } from "../auth/personSessionData"
import MultiSelect from "primevue/multiselect"
import ContextMenu from "primevue/contextmenu"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faInfoCircle,
	faTrash,
	faPen,
	faChartLine,
	faPlusCircle,
	faCloudUpload,
	faTimes,
	faImages,
	faCheck,
	faFlask,
	faTrashXmark,
	faTriangleExclamation,
	faExclamationTriangle,
} from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import FileUpload from "primevue/fileupload"

import { useToast } from "primevue/usetoast"

import {
	ApiClient,
	RawMaterial,
	RawMaterialGlobalData,
	UnitOperation,
	RawMaterialTableRow,
	InboundTransportForMaterials,
	RawMaterialSelectionRow,
	Material,
	AppSettingClient,
} from "../../entities/NSwagGenerated"
import axios from "axios"
import { EventBus } from "../eventBus"

import assessmentTabRawMaterialsSelectionDialog from "./assessmentTabRawMaterialsSelectionDialog.vue"
import warningBlock from "./warningBlock.vue"
import WarningIcon from "./warningIcon.vue"

import { useTabsDefinitions, useSubTabsDefinitions } from "../composables/tabsDefinitions"

import { uiNumberFormatterAZ } from "../composables/AZGlobalFunctions"
import { useRoute } from "vue-router"
import { useErrorToaster, useToaster } from "@/composables/toaster"
import { useDateTimeHelper } from "@/composables/dateTimeHelper"
import { useHistoryHelper } from "@/composables/historyHelper"
import { getEmptyGuid } from "@/composables/guidUtils"

import Popover from "primevue/popover"
import { useAssessmentStore } from "@/store/assessmentStore"
import { useAssessmentLock } from "@/composables/assessmentLock"

const assessmentStore = useAssessmentStore()
const lock = useAssessmentLock(assessmentStore)

//DISABLE Click to request density
const enableRequestDensity = true

const materialDensityToolTip =
	"⚠️ Volume units are not available because this material does not have a density specified." +
	(enableRequestDensity
		? "\n\nClick this warning icon to submit a request for density integration to the application administrator."
		: "\n\nThe density can be added by an administrator upon request.")

const route = useRoute()
const tabsDefinitions = useTabsDefinitions()
const subTabsDefinitions = useSubTabsDefinitions()
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const appSettingClient = new AppSettingClient(import.meta.env.VITE_API_URL?.toString())
const toast = useToast()
const { updateAssessmentUpdatedByDate } = useHistoryHelper()
library.add(
	faTrash,
	faPen,
	faInfoCircle,
	faChartLine,
	faPlusCircle,
	faCloudUpload,
	faTimes,
	faImages,
	faCheck,
	faFlask,
	faTrashXmark,
	faExclamationTriangle,
	faTriangleExclamation
)
const props = defineProps({
	assessmentId: {
		type: String,
		required: true,
		default: "",
	},
	tabName: {
		type: String,
		required: true,
		default: "",
	},
	tabId: {
		type: String,
		required: true,
		default: "",
	},
	subTabName: {
		type: String,
		required: true,
		default: "",
	},
	allTabsInformation: {
		type: Object,
		required: true,
		default: "",
	},
})

// Flag to enable/disable unit operation usage check
const enableCheckIfUnitOperationIsUsed = false

const emit = defineEmits<{
	(e: "materialAdded", material: RawMaterialTableRow): void
	(e: "materialRemoved", id: string, stepId: string): void
	(e: "rawMaterialUpdated", rawMaterial: RawMaterial): void
}>()

//MATERIAL SELECTION DIALOG
const showDialogMaterialSelection = ref(false)
const enableFilterOnMaterial = ref(true)
const selectableMaterials = ref([] as RawMaterialSelectionRow[])

//TAB STATUS
class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}

const displayLoss = ref(false)

//MAIN DATA
const selectedStepName = ref()
const nextPrevEnabled = ref(true)
const thisStepStatus = ref(false)
const saveAttempted = ref(false)
const stepName = ref("")
const stepNumber = ref(0)
const actualUnitOperationId = ref(null)
const proteinMassOutput = ref()
const proteinMOUnit = ref()
const concProteinMassProdOutput = ref()
const concentrationUnit = ref()
const siteLocationName = ref()
const actualStepId = ref()
const actualGeneralInformation = ref()
const actualRawMaterialId = ref()
const productOutputName = ref()
const unitsWeight = ref()
const dosageStrength = ref()
const lifeTimeRef = ref()
const lifeTimeRefUnit = ref()

//UNIT OPS
const addNewUnitOperation = ref(false)
let unitOperation = new UnitOperation()
const dialogDefaultConfirmation = ref(false)
const selectableUnitOperations = ref([])
const unitOperations = ref()
const unitOp = ref()
const selectedUnitOperationForDeleteOrModify = ref()
//FILTERS

//MAIN FORM
const notes = ref()
const massOutput = ref()
const selectedUnit = ref()
const concentrationOutput = ref()
const selectedConcentrationUnit = ref()
const selectedSite = ref()
const selectedUnitOperations = ref([])
const actualUnitOperation = ref([])
const siteLocations = ref()
const unitsDistance = ref()
const unitsConsumables = ref()
const unitsVolume = ref()
const materialSubTypes = ref()
const packagingTypes = ref()
//TABLE
let tablePaginator: any | null = null
const paginatorForDatatable = ref({
	first: 0,
	rows: 10,
	page: 1,
})
let firstRowOfPage = ref(0)
const rawMaterialEntries = ref([] as any[])
const inboundTransportList = ref()
const compactViewMaterialsTable = ref(true)
const showInboundTransport = ref(true)
const selectedRow = ref([] as RawMaterialTableRow[])
const firstForPage = ref(0)
const showVolumeWarning = ref(false)

// Computed property for volume warning messages
const volumeWarningMessages = computed(() => {
	return showVolumeWarning.value ? ["Volume to Mass conversions are assumed to be at 25°C at 1 atmospheric pressure."] : []
})

// Unit operations changes warning
const initialSelectedUnitOperations = ref<string[]>([])
const isInitialLoadComplete = ref<boolean>(false)

// Watch selectedUnitOperations to capture initial state when page loads with existing data
watch(
	selectedUnitOperations,
	(newVal) => {
		// Only set initialSelectedUnitOperations once, when data is first loaded
		// This handles the case where the page loads with existing unit operations from database
		if (!isInitialLoadComplete.value && newVal && newVal.length > 0) {
			initialSelectedUnitOperations.value = [...newVal]
			isInitialLoadComplete.value = true
		}
	},
	{ immediate: true }
)

// Computed to check if current selection is different from initial
const hasUnitOperationChanges = computed(() => {
	// Check if arrays are different (different length or different items)
	if (selectedUnitOperations.value.length !== initialSelectedUnitOperations.value.length) {
		return true
	}

	// Check if all items in current selection exist in initial selection
	const allCurrentInInitial = selectedUnitOperations.value.every((id: string) => initialSelectedUnitOperations.value.includes(id))

	return !allCurrentInInitial
})

const showUnitOperationWarning = computed(() => {
	// Show warning if current state is different from initial saved state
	return hasUnitOperationChanges.value
})

const unitOperationWarningMessages = computed(() => {
	const messages: string[] = []

	if (!hasUnitOperationChanges.value) {
		return messages
	}

	// Check if all initial unit operations have been removed
	const allInitialRemoved =
		initialSelectedUnitOperations.value.length > 0 && initialSelectedUnitOperations.value.every((id) => !selectedUnitOperations.value.includes(id))

	if (allInitialRemoved && selectedUnitOperations.value.length === 0) {
		messages.push("The materials table interface will be updated when you save. The Unit Operation column will be removed.")
		return messages
	}

	// Find removed unit operations (were in initial but not in current)
	const removed = initialSelectedUnitOperations.value.filter((id) => !selectedUnitOperations.value.includes(id))

	// Find added unit operations (are in current but not in initial)
	const added = selectedUnitOperations.value.filter((id: string) => !initialSelectedUnitOperations.value.includes(id))

	if (removed.length > 0) {
		const removedNames = removed
			.map((id) => {
				const unitOp = unitOperations.value.find((op: any) => op.id === id)
				return unitOp ? unitOp.unitOperationName : "Unknown"
			})
			.join(", ")
		messages.push(`Unit operation(s) "${removedNames}" will be removed from selectable options in materials only after saving.`)
	}

	if (added.length > 0) {
		const addedNames = added
			.map((id) => {
				const unitOp = unitOperations.value.find((op: any) => op.id === id)
				return unitOp ? unitOp.unitOperationName : "Unknown"
			})
			.join(", ")
		messages.push(`Unit operation(s) "${addedNames}" will be available for selection in materials only after saving.`)
	}

	return messages
})

//MATERIAL DATATABLE
const loading1 = ref()
const showDialogDelete = ref()
const materialToDelete = ref()
const indexToDelete = ref()
//IMAGE MGM
const image = ref("")
const fileUploader = ref(null)
const imageURL = ref("")
const actualFile = ref()
const updatedImage = ref(false)
const deleteTheImage = ref(false)
const onLoadingImage = ref(true)
const progressSaving = ref(false)

//GENERAL
const materialTypes = ref()
const materials = ref()
const qualityRatings = ref()
const transports = ref()
const editLineId = ref("")
const editLineTransportId = ref("")

//distr
const distTotalDrugProdMass = ref()
const distTotalMassOfPallet = ref()
const distTotalMassIncludingDownstream = ref<number>(0)

//dialog delete transport
const showDialogDeleteTransport = ref(false)
const dialogDeleteTransportMaterialRowId = ref()
const dialogDeleteTransportIndex = ref()

const handleRawMaterialsUpdate = () => {
	const actualTab = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId == props.tabId)

	if (props.subTabName.replace(/\s+/g, "") === actualTab?.actualSubTabName && props.assessmentId === route.query.assessmentId) {
		setPrimaryInformation().then(() => {
			initForm()
		})
	}
}
// const overlays = reactive([])
// const overlays = reactive<Ref<Popover | null>[]>([])
class OverlayDataClass {
	details: string
	description: string | undefined
}
const op = ref<InstanceType<typeof OverlayPanel> | null>(null)
const currentDensityRequestMaterial = ref<RawMaterialSelectionRow | null>(null)
const showDensityDialogVisible = ref(false)
const selectedRowForOverlay = ref<OverlayDataClass>()

// Function to show density dialog
const showDensityDialog = (data: RawMaterialSelectionRow) => {
	currentDensityRequestMaterial.value = data
	showDensityDialogVisible.value = true
}

// Function to handle density request
const requestDensity = async () => {
	const material = currentDensityRequestMaterial.value?.materialName || "Unknown Material"
	try {
		const response = await apiClient.requestDensityForMaterial(currentDensityRequestMaterial.value?.materialId)

		if (response.success) {
			toast.add({
				severity: "success",
				summary: "Request Submitted",
				detail: `Density request for "${material}" has been submitted to ${response.emailsSent || 0} administrator(s).`,
				life: 3000,
			})
		} else {
			// Handle specific error cases based on message
			if (response.message?.includes("No admin users found")) {
				toast.add({
					severity: "warn",
					summary: "No Administrators Available",
					detail: "There are no Client Admin users configured to receive this request. Please contact your system administrator.",
					life: 5000,
				})
			} else if (response.message?.includes("Material not found")) {
				toast.add({
					severity: "error",
					summary: "Material Not Found",
					detail: "The selected material could not be found in the system.",
					life: 5000,
				})
			} else {
				toast.add({
					severity: "error",
					summary: "Request Failed",
					detail: response.message || "Failed to submit density request.",
					life: 5000,
				})
			}
		}
	} catch (err: any) {
		console.error("Connection error:", err)
		toast.add({
			severity: "error",
			summary: "Request Failed",
			detail: "An unexpected error occurred while submitting the request.",
			life: 5000,
		})
	}

	showDensityDialogVisible.value = false
}

const showOverlay = (event: MouseEvent, rowData: RawMaterialTableRow) => {
	selectedRowForOverlay.value = {
		details: getToolTipForAPIProxy(rowData).value,
		description: rowData?.apiProxyDetails?.materialComments,
	}
	if (op.value) op.value?.show(event)
}

const hideOverlay = () => {
	if (op.value) op.value?.hide()
}

onMounted(() => {
	EventBus.on("selectedStep_" + props.tabId, (data: any) => {
		console.log("selectedStep event received in Raw Materials tab with data:", data)
		selectedStepName.value = data.stepName
		actualStepId.value = data.id
		stepName.value = data.stepName
		stepNumber.value = data.stepNumber
		actualUnitOperationId.value = data.unitOperationId
		actualGeneralInformation.value = data.generalInformationId
	})

	EventBus.on(props.subTabName.replace(/\s+/g, "") + "Update" + props.tabId, () => handleRawMaterialsUpdate())

	createNewHighlightStyle()
})
// onUnmounted(() => {
// 	EventBus.off("RawMaterialsUpdate" + props.tabId, () => handleRawMaterialsUpdate())
// })

const getToolTipForAPIProxy = (data: RawMaterialTableRow) => {
	return {
		value:
			"Source Project: <strong>" +
			data.apiProxyDetails?.assessment?.subProject?.project?.projectName +
			"</strong><br>Source SubProject: <strong>" +
			data.apiProxyDetails?.assessment?.subProject?.subProjectName +
			"</strong><br>Source Assessment: <strong>" +
			data.apiProxyDetails?.assessment?.assessmentName +
			"</strong><br>Update Date: <strong>" +
			(data.apiProxyDetails?.lastUpdate ? useDateTimeHelper(data.apiProxyDetails?.lastUpdate!).toLocalTimeZoneStandardFormat() : "") +
			"</strong><br>Update By: <strong>" +
			data.apiProxyDetails?.updatedPerson?.firstName +
			" " +
			data.apiProxyDetails?.updatedPerson?.lastName +
			"</strong>",
		escape: false,
		// class: "custom-tooltip",
	}
}

const addMaterialByFilter = () => {
	showDialogMaterialSelection.value = true
	isModifingMaterial = false
	modMaterial = null
	modMaterialIndex = null
}
const cancelRawMaterialsSelectionDialog = () => {
	showDialogMaterialSelection.value = false
	isModifingMaterial = false
	modMaterial = null
	modMaterialIndex = null
}
let isModifingMaterial: Boolean = false
let modMaterial: RawMaterialTableRow | null | undefined = null
let modMaterialOldValues: RawMaterialTableRow | null | undefined = null
let modMaterialIndex: Number | null = null

const changeMaterialWithDialog = (data: RawMaterialTableRow, index: Number) => {
	isModifingMaterial = true
	modMaterial = data
	modMaterialOldValues = data

	modMaterialIndex = index
	showDialogMaterialSelection.value = true
}

const selectMaterial = (selectedMaterial: RawMaterialSelectionRow) => {
	addSelectedMaterialFromDialog(selectedMaterial)
}

const shouldShowUnitOperationColumn = computed(
	() =>
		props.tabName === tabsDefinitions.syntheticAPI.value && Array.isArray(selectableUnitOperations.value) && selectableUnitOperations.value.length > 0
)

// Unit operation is required if user has selected any unit operations in the main form
const isUnitOperationRequired = computed(
	() => props.tabName === tabsDefinitions.syntheticAPI.value && Array.isArray(selectedUnitOperations.value) && selectedUnitOperations.value.length > 0
)

// Helper function to group and sort units
const createGroupedUnits = (units: any[]): { label: string; items: any[] }[] => {
	if (!Array.isArray(units) || units.length === 0) return []

	// Group by unitTypeName
	const grouped = units.reduce(
		(acc, unit) => {
			const typeName = unit.unitType?.unitTypeName || "Other"
			if (!acc[typeName]) {
				acc[typeName] = []
			}
			acc[typeName].push(unit)
			return acc
		},
		{} as Record<string, any[]>
	)

	// Convert to PrimeVue optionGroup format and sort within each group
	return Object.keys(grouped).map((typeName) => ({
		label: typeName,
		items: grouped[typeName].sort((a: any, b: any) => {
			const aMultiplier = a.convertToStandardMultiplier || 0
			const bMultiplier = b.convertToStandardMultiplier || 0
			return aMultiplier - bMultiplier
		}),
	}))
}

// Computed properties for grouped units
const groupedWeightAndVolumeUnits = computed(() => {
	const allUnits = [...(unitsWeight.value || []), ...(unitsVolume.value || [])]
	return createGroupedUnits(allUnits)
})

const groupedConsumableUnits = computed(() => {
	return createGroupedUnits(unitsConsumables.value || [])
})

const groupedDistanceUnits = computed(() => {
	return createGroupedUnits(unitsDistance.value || [])
})

// Function to get grouped units based on material type (for table dropdown)
const getGroupedUnitsForMaterial = (data: any) => {
	const shouldUseConsumables =
		(props.tabName !== tabsDefinitions.distribution.value && data.materialTypeName === "Consumables") ||
		(props.tabName === tabsDefinitions.distribution.value && data.materialSubTypeName !== "Others")

	if (shouldUseConsumables) {
		return groupedConsumableUnits.value
	} else {
		return groupedWeightAndVolumeUnits.value
	}
}

watchEffect(() => {
	if (Array.isArray(selectableUnitOperations.value) && selectableUnitOperations.value.length === 1 && Array.isArray(rawMaterialEntries)) {
		const defaultId = selectableUnitOperations.value[0].id

		for (const entry of rawMaterialEntries) {
			// Only assign if it's not already set
			if (entry.unitOperationId == null) {
				entry.unitOperationId = defaultId
			}
		}
	}
})

const updateTransportForChangedMaterial = (singleRow: RawMaterialTableRow) => {
	var findInboundToModify = inboundTransportList.value.findIndex((item: InboundTransportForMaterials) => item.materialRowId === singleRow.id)
	if (findInboundToModify !== -1) {
		inboundTransportList.value[findInboundToModify].materialName = singleRow.materialName
		inboundTransportList.value[findInboundToModify].materialId = !singleRow.isAPIProxy ? singleRow.materialId : null
		inboundTransportList.value[findInboundToModify].materialRowId = singleRow.id
		inboundTransportList.value[findInboundToModify].productProcessProxyId = singleRow.isAPIProxy ? singleRow.productProcessProxyId : null
	}
}

async function addSelectedMaterialFromDialog(selectedMaterial: RawMaterialSelectionRow) {
	var materialTypeForPieces: string[] = ["Consumables", "Container"]
	let singleRow = new RawMaterialTableRow()
	singleRow.id = isModifingMaterial ? modMaterial!.id : getEmptyGuid()
	singleRow.isNew = !isModifingMaterial ? true : false
	singleRow.materialId = selectedMaterial.materialId
	singleRow.intermediateId = selectedMaterial.intermediateId
	singleRow.isIntermediate = selectedMaterial.isIntermediate
	singleRow.isSourceMaterialActive = selectedMaterial.isActive
	singleRow.isAPIProxy = selectedMaterial.isAPIProxy
	singleRow.apiProxyDetails = selectedMaterial.apiProxyDetails
	singleRow.isProxy = selectedMaterial.isProxy
	singleRow.materialName = selectedMaterial.materialName
	singleRow.materialTypeName = selectedMaterial.categoryName
	singleRow.materialSubTypeName = selectedMaterial.subCategoryName
	singleRow.materialTypeId = selectedMaterial.materialCategoryId
	singleRow.cas = selectedMaterial.cas
	singleRow.density = selectedMaterial.density
	singleRow.stepId = actualStepId.value
	singleRow.assessmentId = props.assessmentId
	singleRow.rawMaterialId = actualRawMaterialId.value
	// For Packaging/Distribution tabs, include generalInformationId for proper filtering
	if (props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value) {
		singleRow.generalInformationId = actualGeneralInformation.value
	}
	// Preserve existing quantity and unit when modifying material, otherwise set to 0
	if (isModifingMaterial && modMaterial) {
		singleRow.quantity = modMaterial.quantity
		singleRow.unitId = modMaterial.unitId
		singleRow.unitName = modMaterial.unitName
		// Note: density comes from the selected material, not preserved from modMaterial
	} else {
		singleRow.quantity = 0
	}

	// Set default unit only for new materials or when unit is not preserved
	if (selectedMaterial.categoryName !== undefined && selectedMaterial.categoryName !== null && (!isModifingMaterial || !modMaterial?.unitId)) {
		if (
			materialTypeForPieces.includes(selectedMaterial.categoryName) ||
			(tabsDefinitions.distribution.value === props.tabName && selectedMaterial.subCategoryName !== "Others")
		) {
			singleRow.unitId = unitsConsumables.value[0].id
			singleRow.unitName = unitsConsumables.value[0].unitName
		} else {
			singleRow.unitId = null
			singleRow.unitName = ""
		}
	}
	//67472
	// if (props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value) {
	// 	singleRow.unitOperationId = actualUnitOperationId.value
	// } else {
	// 	if (selectableUnitOperations.value.length === 1) {
	// 		singleRow.unitOperationId = selectableUnitOperations.value[0].id
	// 		singleRow.unitOperationName = selectableUnitOperations.value[0].unitOperationName
	// 	} else {
	// 		singleRow.unitOperationId = null
	// 		singleRow.unitOperationName = ""
	// 	}
	// }
	if (props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value) {
		singleRow.unitOperationId = actualUnitOperationId.value
	} else if (props.tabName === tabsDefinitions.syntheticAPI.value) {
		if (selectableUnitOperations.value.length === 1) {
			singleRow.unitOperationId = selectableUnitOperations.value[0].id
			singleRow.unitOperationName = selectableUnitOperations.value[0].unitOperationName
		}
	} else {
		singleRow.unitOperationId = null
		singleRow.unitOperationName = ""
	}
	// singleRow.unitOperationId =
	// 	props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value ? actualUnitOperationId.value : null
	// singleRow.unitOperationName = ""
	// Preserve existing carbon footprint when modifying material, otherwise set to 0
	if (isModifingMaterial && modMaterial) {
		singleRow.carbonFootprint = modMaterial.carbonFootprint
	} else {
		singleRow.carbonFootprint = 0
	}
	singleRow.dataQualityRatingId = undefined
	singleRow.dataQualityRatingName = ""
	singleRow.dataQualityScore = selectedMaterial.dataQualityRatingScore?.toString()
	singleRow.supplierName = ""
	singleRow.supplierLocation = ""
	singleRow.materials = props.tabName === tabsDefinitions.distribution.value ? materials.value : null
	if (!isModifingMaterial) {
		singleRow.createdTimeStamp = new Date()
	}
	singleRow.referenceQuantity = subTabsDefinitions.deviceMaterials.value.id === "11b05cc3-a137-4e55-ac1a-3857bc54f2f6" ? lifeTimeRef.value : null

	if (isModifingMaterial && modMaterialIndex !== null) {
		rawMaterialEntries.value[modMaterialIndex as number] = singleRow
		updateTransportForChangedMaterial(singleRow)
		// Carbon footprint will be calculated after save completes
	} else {
		rawMaterialEntries.value.push(singleRow as RawMaterialTableRow)
	}

	var numNewRows = rawMaterialEntries.value.filter((item: any) => item.isNew == true).length

	var line = rawMaterialEntries.value.length - 1

	if (numNewRows > 0) {
		findAndShowRow(line)
	}

	// Focus and select quantity input after material selection from modal
	nextTick(() => {
		const dataId = singleRow.id
		if (dataId) {
			const quantityInput = document.getElementById(`quantityInput_${dataId}`) as HTMLInputElement
			if (quantityInput) {
				quantityInput.focus()
				quantityInput.select()
			}
		}
		if (isModifingMaterial && modMaterialIndex !== null) {
			if (
				(props.tabName !== tabsDefinitions.distribution.value &&
					rawMaterialEntries.value[modMaterialIndex as number].materialTypeName === "Consumables") ||
				(props.tabName === tabsDefinitions.distribution.value &&
					rawMaterialEntries.value[modMaterialIndex as number].materialSubTypeName !== "Others")
			) {
				rawMaterialEntries.value[modMaterialIndex as number].unitId = unitsConsumables.value[0].id
				rawMaterialEntries.value[modMaterialIndex as number].unitName = unitsConsumables.value[0].unitName
			} else {
				if (
					modMaterialOldValues &&
					modMaterialOldValues.materialTypeName === "Consumables" &&
					rawMaterialEntries.value[modMaterialIndex as number].materialTypeName !== "Consumables"
				) {
					rawMaterialEntries.value[modMaterialIndex as number].unitId = null
					rawMaterialEntries.value[modMaterialIndex as number].unitName = ""
				}
			}
		}
		nextTick().then(() => {
			saveMaterialInDb("materialName", modMaterialIndex as number)
		})
	})

	showDialogMaterialSelection.value = false
}

function findAndShowRow(line: number) {
	firstRowOfPage.value = Math.floor(line / paginatorForDatatable.value.rows) * paginatorForDatatable.value.rows
	selectedRow.value = [rawMaterialEntries.value[line]]
	scrollToMatrialTable()
}
// watch(
// 	rawMaterialEntries,
// 	(entries) => {
// 	},
// 	{ deep: true }
// )

// //GET DATA FROM LocalStorage
// function getLocalStorageForTypeId(): Promise<tabActualStatus> {
// 	return new Promise((resolve, reject) => {
// 		var localStorageActualTabs: string | null = localStorage.getItem("actualTabsStatus") !== null ? localStorage.getItem("actualTabsStatus") : ""
// 		if (localStorageActualTabs === null) reject("ErrorLine1136")
// 		var tabStatus: allTabsActualStatus = JSON.parse(localStorageActualTabs) as allTabsActualStatus
// 		var toGetStatus = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
// 		if (toGetStatus === undefined) {
// 			reject(null)
// 		} else {
// 			resolve(toGetStatus)
// 		}
// 	})
// }
//PRIMARY INFO
//setting main informations
async function setPrimaryInformation(): Promise<string> {
	return new Promise((resolve, reject) => {
		// var localStorageActualTabs: string | null = localStorage.getItem("actualTabsStatus") !== null ? localStorage.getItem("actualTabsStatus") : ""
		// if (localStorageActualTabs === null) reject("ErrorLine1136")
		// var tabStatus: allTabsActualStatus = JSON.parse(localStorageActualTabs) as allTabsActualStatus
		// var toGetStatus = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
		// getLocalStorageForTypeId("load", null, props.tabId)
		// 	.then((valueFromTabs: tabActualStatus | boolean) => {
		// 		actualStepId.value = valueFromTabs === undefined ? 0 : valueFromTabs.selectedStepId
		// 		actualGeneralInformation.value = valueFromTabs === undefined ? "" : valueFromTabs.generalInformationId
		// 	})
		// 	.then(() => {
		// 		resolve("Done")
		// 	})
		actualStepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
		actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
			(item: any) => item.actualMainTabId === props.tabId
		).generalInformationId
		resolve("Done")
	})
}

//main form initialization
async function initForm(): Promise<boolean> {
	try {
		resetAll()
		onLoadingImage.value = false

		const dropdownsResult = await getRawMaterialsRelatedDropdownsv2()
		if (dropdownsResult !== "Done") {
			return false
		}

		const basicInfoResult = await loadBasicInfo()
		if (basicInfoResult !== "Done") {
			return false
		}

		await loadAllDetailsv0()
		return true
	} catch (err) {
		console.error("Error in initForm:", err)
		return false
	}
}
function createNewHighlightStyle() {
	var style = document.createElement("style")
	style.type = "text/css"

	// Set the CSS rules
	style.textContent =
		`
::v-deep(#dtRawMaterialList_` +
		props.tabId +
		` .p-datatable-wrapper table .p-datatable-tbody) {
	.p-selectable-row.p-highlight {
		background-color: #fcd34d;
	}
}
`

	// Add the <style> element to the document's <head> element
	document.head.appendChild(style)
}
function deleteMaterial(ev: any, dataId: any) {
	materialToDelete.value = ev
	indexToDelete.value = rawMaterialEntries.value.findIndex((item: any) => item.id === dataId)
	showDialogDelete.value = true
}
function deleteMaterialOK() {
	removeAddedMaterial(materialToDelete.value, indexToDelete.value)
	materialToDelete.value = null
	indexToDelete.value = null
	EventBus.emit("checkIfEnableConsumerEndOfLifeTab")
}
function removeAddedMaterial(ev: any, index: any) {
	if (ev.isNew) {
		// Unsaved material: remove from local array only, no API call needed
		rawMaterialEntries.value.splice(index, 1)
		showDialogDelete.value = false
		emit("materialRemoved", ev.id, actualStepId.value)
		return
	}

	// Saved material: call API to soft-delete from database
	rawMaterialEntries.value[index].stepId = actualStepId.value
	rawMaterialEntries.value[index].rawMaterialId = actualRawMaterialId.value

	apiClient.delSingleMaterialFromTable(rawMaterialEntries.value[index]).then((res) => {
		rawMaterialEntries.value = rawMaterialEntries.value.filter((item: any) => item.id !== ev.id)
		inboundTransportList.value = inboundTransportList.value.filter((item: any) => item.materialRowId !== ev.id)
		showDialogDelete.value = false
		// We need to emit the event to update the step graph
		emit("materialRemoved", ev.id, actualStepId.value)
		// For Packaging/Distribution tabs, use generalInformationId to get correct total mass
		const isPackagingOrDistribution = props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value
		apiClient
			.getTotalMassForDistribution(actualStepId.value, isPackagingOrDistribution ? actualGeneralInformation.value : undefined)
			.then((res) => {
				distTotalMassIncludingDownstream.value = res
			})
			.then(() => {
				useToaster({
					summary: "Success",
					detail: "Material deleted successfully",
					severity: "success",
					life: 3000,
				})
			})
	})
}
//click outside trick
function clickOutside() {
	document.getElementById("clickOutside")?.dispatchEvent(
		new MouseEvent("click", {
			bubbles: true,
			cancelable: true,
			view: window,
		})
	)
}
//material datatable functions
function pageChanged(ev: any) {
	scrollToMatrialTable()
	tablePaginator = ev
	paginatorForDatatable.value = {
		first: ev.first,
		rows: ev.rows,
		page: ev.page + 1,
	}
	localStorage.setItem("projectListPaginate", JSON.stringify(ev))
}
//button compact view on material table
function compactViewMaterialsTableNow() {
	compactViewMaterialsTable.value = !compactViewMaterialsTable.value
}
//emitting event for page status checks when user click next prev
function changePage(action: string) {
	if (action === "next") {
		if (!assessmentStore.isLocked) {
			// Save only if not locked
			saveRawMaterials(true)
		}
	}
	// Always emit the event to change page
	EventBus.emit("nextPreviousTab_" + props.tabId, {
		action: action,
		actualTab: props.tabId,
	})
}

//accept only numbers in numeric field.
function onlyNumbers(evt: any) {
	evt = evt ? evt : window.event
	var charCode = evt.which ? evt.which : evt.keyCode
	if (
		(charCode != 46 || evt.target.value.indexOf(".") != -1) && // "." CHECK DOT, AND ONLY ONE.
		(charCode < 48 || charCode > 57)
	) {
		evt.preventDefault()
		return false
	} else {
		return true
	}
}

/**
 * Checks if all required fields for a specific screen are filled for a given row
 * @param index - The index of the row in rawMaterialEntries array
 * @param screenName - The name of the screen to check (tabName)
 * @param subScreenName - Optional sub-screen name (subTabName)
 * @returns Object with isValid boolean and array of missing field names
 */
function checkRowPerScreenMaterial(index: number, screenName: string, subScreenName?: string) {
	if (index < 0 || index >= rawMaterialEntries.value.length) {
		return { isValid: false, missingFields: ["Invalid row index"] }
	}

	const data = rawMaterialEntries.value[index]
	const missingFields: string[] = []

	// Common required fields for all screens
	if (data.quantity === 0 || data.quantity === null || data.quantity === "") {
		missingFields.push("Quantity")
	}

	if (data.materialId === null || data.materialId === undefined) {
		missingFields.push("Material")
	}

	// Screen-specific validations
	switch (screenName) {
		case tabsDefinitions.packaging.value:
			// Component Name is required for packaging
			if (data.componentName == null || data.componentName === "") {
				missingFields.push("Component Name")
			}

			// Material Sub Type is required for packaging
			if (data.materialSubTypeId === null || data.materialSubTypeId === undefined) {
				missingFields.push("Material Type")
			}

			// Unit is required for packaging
			if (data.unitId === null || data.unitId === undefined) {
				missingFields.push("Unit")
			}

			// Packaging Type is required for Packaging Materials sub-screen
			if (subScreenName === subTabsDefinitions.packagingMaterials.value.label) {
				if (data.packagingTypeId === null || data.packagingTypeId === undefined) {
					missingFields.push("Packaging Type")
				}
			}
			break

		case tabsDefinitions.distribution.value:
			// Material Sub Type is required for distribution
			if (data.materialSubTypeId === null || data.materialSubTypeId === undefined) {
				missingFields.push("Material Type")
			}

			// Unit is required for distribution
			if (data.unitId === null || data.unitId === undefined) {
				missingFields.push("Unit")
			}
			break

		case tabsDefinitions.productProcess.value:
			// Material Type is required for product process
			if (data.materialTypeId === null || data.materialTypeId === undefined) {
				missingFields.push("Material Category")
			}

			// Unit is required for product process
			if (data.unitId === null || data.unitId === undefined) {
				missingFields.push("Unit")
			}

			// Unit Operation is required if shouldShowUnitOperationColumn is true
			if (shouldShowUnitOperationColumn.value && (data.unitOperationId === null || data.unitOperationId === undefined)) {
				missingFields.push("Unit Operations")
			}
			break

		case tabsDefinitions.biologics.value:
			// Material Type is required for biologics
			if (data.materialTypeId === null || data.materialTypeId === undefined) {
				missingFields.push("Material Category")
			}

			// Unit is required for biologics
			if (data.unitId === null || data.unitId === undefined) {
				missingFields.push("Unit")
			}
			break

		case tabsDefinitions.syntheticAPI.value:
			// Material Type is required for synthetic API
			if (data.materialTypeId === null || data.materialTypeId === undefined) {
				missingFields.push("Material Category")
			}

			// Unit is required for synthetic API
			if (data.unitId === null || data.unitId === undefined) {
				missingFields.push("Unit")
			}
			break

		default:
			// For any other screen, check basic material type
			if (data.materialTypeId === null || data.materialTypeId === undefined) {
				missingFields.push("Material Category")
			}
			break
	}

	return {
		isValid: missingFields.length === 0,
		missingFields: missingFields,
	}
}

//clear all fields content
function resetAll() {
	saveAttempted.value = false
	notes.value = null
	massOutput.value = null
	selectedUnit.value = null
	selectedSite.value = null
	concentrationOutput.value = null
	selectedConcentrationUnit.value = null
	image.value = ""
	selectedUnitOperations.value = []
	initialSelectedUnitOperations.value = []
	isInitialLoadComplete.value = false // Reset flag so next load captures initial state
	actualRawMaterialId.value = null
	rawMaterialEntries.value = []
	inboundTransportList.value = []
	proteinMassOutput.value = null
	proteinMOUnit.value = null
	concProteinMassProdOutput.value = null
	concentrationUnit.value = null
	siteLocationName.value = null
	productOutputName.value = null
	distTotalMassIncludingDownstream.value = 0
	distTotalMassOfPallet.value = ""
	distTotalDrugProdMass.value = ""
}

const checkUnitType = (unitId: string | undefined) => {
	if (!unitId) return null
	const isConsumableUnit = unitsConsumables.value.some((unit: any) => unit.id === unitId)
	return isConsumableUnit ? "consumable" : "weightVolume"
}

//get all the dropdowns for raw materials
function getRawMaterialsRelatedDropdowns(): Promise<string> {
	return new Promise((resolve, reject) => {
		apiClient
			.getRawMaterialsRelatedDropdowns(props.tabId, props.assessmentId)
			.then((res) => {
				unitsDistance.value = res.unitsDistance
				unitsWeight.value = res.unitsWeight
				unitsConsumables.value = res.unitsConsumable
				unitsVolume.value = res.unitsVolume
				siteLocations.value = res.locations
				unitOperations.value = res.unitOperations
				materialTypes.value = res.materialTypes
				materials.value =
					props.tabName === tabsDefinitions.distribution.value
						? res.materials
						: res.materials?.filter((el) => el.materialName !== selectedStepName.value)
				// materials.value =	res.materials?.filter((el) => el.materialName !== selectedStepName.value)
				qualityRatings.value = res.qualityRatings
				transports.value = res.transports
				materialSubTypes.value = res.materialSubType
				packagingTypes.value = res.packagingTypes
			})
			.then(() => {
				resolve("Done")
			})
	})
}
function getRawMaterialsRelatedDropdownsv2(): Promise<string> {
	return new Promise((resolve, reject) => {
		apiClient
			.getRawMaterialsRelatedDropdownsv2(props.tabId, actualGeneralInformation.value)
			.then((res) => {
				unitsDistance.value = res.unitsDistance
				unitsWeight.value = res.unitsWeight
				unitsConsumables.value = res.unitsConsumable
				unitsVolume.value = res.unitsVolume
				siteLocations.value = res.locations
				unitOperations.value = res.unitOperations
				selectableMaterials.value =
					props.tabName === tabsDefinitions.biologics.value
						? res.rawMaterialSelectionRow?.filter((item: any) => !item.isIntermediate) || []
						: res.rawMaterialSelectionRow || []
				// materials.value =	res.materials?.filter((el) => el.materialName !== selectedStepName.value)
				qualityRatings.value = res.qualityRatings
				transports.value = res.transports

				packagingTypes.value = res.packagingTypes
			})
			.then(() => {
				resolve("Done")
			})
	})
}
//load main information for the form
function loadBasicInfo(): Promise<string> {
	return new Promise((resolve, reject) => {
		// For Packaging/Distribution tabs, use the specific generalInformationId to get correct data
		const isPackagingOrDistribution = props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value

		const apiCall =
			isPackagingOrDistribution && actualGeneralInformation.value
				? apiClient.getGeneralInformationById(actualGeneralInformation.value)
				: apiClient.getCommonAPISingleGeneralByAssessmentIdAndScreenId(props.assessmentId, props.tabId)

		apiCall.then((res) => {
			if (res) {
				switch (props.tabName) {
					case tabsDefinitions.biologics.value:
						proteinMassOutput.value = res.proteinMassOutput
						proteinMOUnit.value = res.proteinMOUnit !== null && res.proteinMOUnit !== undefined ? res.proteinMOUnit.unitName : null
						concProteinMassProdOutput.value = res.concProteinMassProdOutput
						concentrationUnit.value = res.concentrationUnit !== null && res.concentrationUnit !== undefined ? res.concentrationUnit.unitName : null
						siteLocationName.value = res.siteLocation !== null && res.siteLocation !== undefined ? res.siteLocation.siteLocationName : null
						break
					case tabsDefinitions.productProcess.value:
						proteinMassOutput.value = res.proteinMassOutput
						proteinMOUnit.value = res.proteinMOUnit !== null && res.proteinMOUnit !== undefined ? res.proteinMOUnit.unitName : null
						concProteinMassProdOutput.value = res.concProteinMassProdOutput
						concentrationUnit.value = res.concentrationUnit !== null && res.concentrationUnit !== undefined ? res.concentrationUnit.unitName : null
						siteLocationName.value = res.siteLocation !== null && res.siteLocation !== undefined ? res.siteLocation.siteLocationName : null
						if (res.isDefaultLoaction) {
							selectedSite.value = siteLocations.value.find((item: any) => item.siteLocationName === "Global").id
						}
						break
					case tabsDefinitions.packaging.value:
						dosageStrength.value = res.packDoseStrength != null ? res.packDoseStrength : null
						lifeTimeRef.value = res.packLifetimeRefUnitsPerDevice != null ? res.packLifetimeRefUnitsPerDevice : null
						lifeTimeRefUnit.value = res.packReferenceUnit !== null && res.packReferenceUnit !== undefined ? res.packReferenceUnit.valueTxt : null
						break
					case tabsDefinitions.distribution.value:
						distTotalDrugProdMass.value =
							res.distDrugProductMass !== null && res.distDrugProductMassUnit !== undefined
								? res.distDrugProductMass + " " + res.distDrugProductMassUnit.unitName
								: null
						distTotalMassOfPallet.value = res.distTotalMassOfPallet + " kg"
						break
				}
				resolve("Done")
			} else {
				switch (props.tabName) {
					case tabsDefinitions.productProcess.value:
						apiClient.getCommonAPIGeneralByAssessmentIdAndScreenId(props.assessmentId, props.tabId).then((res) => {
							if (res.isDefaultLoaction === true) {
								siteLocationName.value = selectedSite.value === siteLocations.value.find((item: any) => item.siteLocationName === "Global").id
							}
						})
						siteLocationName.value = null
						break
				}
				resolve("Done")
			}
		})
	})
}
async function loadAllDetailsv0() {
	clearImage()
	progressSaving.value = true
	// var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
	// var toGetStatus = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
	//selectedStepName.value = toGetStatus.actualSubTabName
	actualStepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
	actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
		(item: any) => item.actualMainTabId === props.tabId
	).generalInformationId
	var rawMatScreens = undefined

	switch (props.subTabName) {
		case subTabsDefinitions.deviceMaterials.value.label:
			rawMatScreens = subTabsDefinitions.deviceMaterials.value.id
			break
		case subTabsDefinitions.packagingMaterials.value.label:
			rawMatScreens = subTabsDefinitions.packagingMaterials.value.id
			break
		default:
			rawMatScreens = undefined
			break
	}
	if (actualGeneralInformation.value === undefined || actualStepId.value === undefined || props.tabId === undefined) return

	const res = await apiClient.getRawMaterialsByGeneraInformationIdScreenIdStepId(
		actualGeneralInformation.value,
		props.tabId,
		actualStepId.value,
		rawMatScreens
	)

	if (res !== null) {
		notes.value = res.note
		massOutput.value = res.massOfProduct
		selectedUnit.value = res.unitId

		selectedConcentrationUnit.value = res.bdsUnitId
		concentrationOutput.value = res.bdsConcentration
		productOutputName.value = res.productOutputName
		image.value = res.image ? res.image : ""

		// Collect unit operations first
		const unitOpsToAdd: string[] = []
		res.rawMaterialUnitOperation
			?.sort((a, b) => a.position - b.position)
			.forEach((el) => {
				if (el.isActive) {
					unitOpsToAdd.push(el.unitOperationId)
					actualUnitOperation.value.push(el.unitOperationId)
				}
			})

		// Use nextTick to ensure options are rendered before setting selected values
		await nextTick()

		// Now set the selected values
		selectedSite.value = res.siteLocationId
		selectedUnitOperations.value = unitOpsToAdd

		selectableUnitOperations.value = unitOperations.value.filter((item) => selectedUnitOperations.value.includes(item.id))

		// Store initial selected unit operations for warning logic
		initialSelectedUnitOperations.value = [...selectedUnitOperations.value]

		actualRawMaterialId.value = res.id
		EventBus.emit("nextPrevEnabled_" + props.tabId)

		if (res.id !== null) {
			await getMaterialsEntriesByGeneraInformationIdScreenId(
				actualRawMaterialId.value,
				actualStepId.value,
				props.tabId,
				actualGeneralInformation.value
			)
			thisStepStatus.value = true
			onLoadingImage.value = true
			progressSaving.value = false
			deleteTheImage.value = false
		}
	} else {
		onLoadingImage.value = true
		thisStepStatus.value = false
		progressSaving.value = false
		deleteTheImage.value = false
		if (
			props.tabName === tabsDefinitions.packaging.value ||
			props.tabName === tabsDefinitions.biologics.value ||
			props.tabName === tabsDefinitions.distribution.value
		) {
			saveRawMaterials(false)
		}
	}
}

const getMaterialsEntriesByGeneraInformationIdScreenId = (
	materialId: string,
	stepId: string,
	screenId: string,
	generalInformationId: string
): Promise<boolean> => {
	return new Promise((resolve, reject) => {
		let materialNotAllowedToHaveTransport = ["Tap water", "Tap water (cleaning)", "WFI", "WFI (cleaning)"]
		loading1.value = true
		apiClient.getMaterialsEntriesByGeneraInformationIdScreenId(materialId, stepId, screenId, generalInformationId).then((res) => {
			rawMaterialEntries.value = res.rawMaterialTableRows || []
			if (tabsDefinitions.distribution.value === props.tabName) {
				distTotalMassIncludingDownstream.value = res.totalMass!
			}
			checkVolumeUnitsUsage()
			inboundTransportList.value = []
			res.allMaterialInboundTransport?.forEach((single) => {
				if (materialNotAllowedToHaveTransport.indexOf(single.materialName!) === -1) {
					var le = single.allTransportsForMaterial?.length
					var newEmptyObj = new InboundTransportForMaterials()
					newEmptyObj.materialId = single.materialId
					newEmptyObj.materialName = single.materialName
					newEmptyObj.isIntermediate = single.isIntermediate
					newEmptyObj.intermediateStepId = single.intermediateStepId
					newEmptyObj.isTitle = true
					newEmptyObj.id = self.crypto.randomUUID()
					newEmptyObj.materialRowId = single.materialRowId
					newEmptyObj.numOfInbound = le
					inboundTransportList.value.push(newEmptyObj)

					single.allTransportsForMaterial?.forEach((single, index) => {
						var newEmptyObj = new InboundTransportForMaterials()
						newEmptyObj.materialId = !single.isIntermediate || !single.isAPIProxy ? single.materialId : null
						newEmptyObj.intermediateStepId = single.isIntermediate ? single.intermediateStepId : null
						newEmptyObj.productProcessProxyId = single.isAPIProxy ? single.productProcessProxyId : null
						newEmptyObj.materialName = ""
						newEmptyObj.modeOfTransportId = single.modeOfTransportId
						newEmptyObj.modeOfTransport = single.modeOfTransport
						newEmptyObj.distance = single.distance
						newEmptyObj.unitId = single.unitId
						newEmptyObj.unitName = single.unitName
						newEmptyObj.isEditable = true
						newEmptyObj.isTitle = false
						newEmptyObj.isIntermediate = single.isIntermediate
						newEmptyObj.isAPIProxy = single.isAPIProxy
						newEmptyObj.isNew = false
						newEmptyObj.id = single.id
						newEmptyObj.materialRowId = single.materialRowId
						newEmptyObj.lastOne = index === le - 1 ? true : false
						inboundTransportList.value.push(newEmptyObj)
					})
					if (le === 0) {
						var newEmptyObj = new InboundTransportForMaterials()
						newEmptyObj.materialId = !single.isIntermediate || !single.isAPIProxy ? single.materialId : null
						newEmptyObj.intermediateStepId = single.isIntermediate ? single.intermediateStepId : null
						newEmptyObj.productProcessProxyId = single.isAPIProxy ? single.productProcessProxyId : null
						newEmptyObj.materialName = ""
						newEmptyObj.modeOfTransportId = null
						newEmptyObj.modeOfTransport = null
						newEmptyObj.distance = null
						newEmptyObj.unitId = null
						newEmptyObj.unitName = null
						newEmptyObj.isEditable = true
						newEmptyObj.isIntermediate = single.isIntermediate
						newEmptyObj.isAPIProxy = single.isAPIProxy
						newEmptyObj.isNew = false
						newEmptyObj.id = self.crypto.randomUUID()
						//newEmptyObj.materialRowId = single.materialRowId
						newEmptyObj.numOfInbound = le
						newEmptyObj.lastOne = true
						newEmptyObj.isTitle = false
						newEmptyObj.materialRowId = single.materialRowId
						inboundTransportList.value.push(newEmptyObj)
					}
				}
			})
			loading1.value = false
		})

		resolve(true)
	})
}

//get all materials and inboundtransport data
function getMaterialsEntriesByGeneraInformationIdScreenIdOLD(materialId: string, stepId: string, screenId: string, generalInformationId: string) {
	let materialNotAllowedToHaveTransport = ["Tap water", "Tap water (cleaning)", "WFI", "WFI (cleaning)"]
	apiClient.getMaterialsEntriesByGeneraInformationIdScreenId(materialId, stepId, screenId, generalInformationId).then((res) => {
		rawMaterialEntries.value = res.rawMaterialTableRows || []
		if (tabsDefinitions.distribution.value === props.tabName) {
			distTotalMassIncludingDownstream.value = res.totalMass!
		}
		checkVolumeUnitsUsage()
		inboundTransportList.value = []
		res.allMaterialInboundTransport?.forEach((single) => {
			if (materialNotAllowedToHaveTransport.indexOf(single.materialName) === -1) {
				var le = single.allTransportsForMaterial?.length
				var newEmptyObj = new InboundTransportForMaterials()
				newEmptyObj.materialId = single.materialId
				newEmptyObj.materialName = single.materialName
				newEmptyObj.isIntermediate = single.isIntermediate
				newEmptyObj.intermediateStepId = single.intermediateStepId
				newEmptyObj.isTitle = true
				newEmptyObj.id = self.crypto.randomUUID()
				newEmptyObj.materialRowId = single.materialRowId
				newEmptyObj.numOfInbound = le
				inboundTransportList.value.push(newEmptyObj)

				single.allTransportsForMaterial?.forEach((single, index) => {
					var newEmptyObj = new InboundTransportForMaterials()
					newEmptyObj.materialId = !single.isIntermediate || !single.isAPIProxy ? single.materialId : null
					newEmptyObj.intermediateStepId = single.isIntermediate ? single.intermediateStepId : null
					newEmptyObj.productProcessProxyId = single.isAPIProxy ? single.productProcessProxyId : null
					newEmptyObj.materialName = ""
					newEmptyObj.modeOfTransportId = single.modeOfTransportId
					newEmptyObj.modeOfTransport = single.modeOfTransport
					newEmptyObj.distance = single.distance
					newEmptyObj.unitId = single.unitId
					newEmptyObj.unitName = single.unitName
					newEmptyObj.isEditable = true
					newEmptyObj.isTitle = false
					newEmptyObj.isIntermediate = single.isIntermediate
					newEmptyObj.isAPIProxy = single.isAPIProxy
					newEmptyObj.isNew = false
					newEmptyObj.id = single.id
					newEmptyObj.materialRowId = single.materialRowId
					newEmptyObj.lastOne = index === le - 1 ? true : false
					inboundTransportList.value.push(newEmptyObj)
				})
				if (le === 0) {
					var newEmptyObj = new InboundTransportForMaterials()
					newEmptyObj.materialId = !single.isIntermediate || !single.isAPIProxy ? single.materialId : null
					newEmptyObj.intermediateStepId = single.isIntermediate ? single.intermediateStepId : null
					newEmptyObj.productProcessProxyId = single.isAPIProxy ? single.productProcessProxyId : null
					newEmptyObj.materialName = ""
					newEmptyObj.modeOfTransportId = null
					newEmptyObj.modeOfTransport = null
					newEmptyObj.distance = null
					newEmptyObj.unitId = null
					newEmptyObj.unitName = null
					newEmptyObj.isEditable = true
					newEmptyObj.isIntermediate = single.isIntermediate
					newEmptyObj.isAPIProxy = single.isAPIProxy
					newEmptyObj.isNew = false
					newEmptyObj.id = self.crypto.randomUUID()
					//newEmptyObj.materialRowId = single.materialRowId
					newEmptyObj.numOfInbound = le
					newEmptyObj.lastOne = true
					newEmptyObj.isTitle = false
					newEmptyObj.materialRowId = single.materialRowId
					inboundTransportList.value.push(newEmptyObj)
				}
			}
		})
	})
}
function removeAddedTransportOK(ev: any, index: number) {
	var countOfMaterialInbound = inboundTransportList.value.filter((item: any) => item.materialRowId === ev.materialRowId).length
	canDeleteInbound.value = false
	if (countOfMaterialInbound > 2) {
		apiClient.deleteInboundFromTable(inboundTransportList.value[index]).then((res) => {
			inboundTransportList.value.splice(index, 1)
			canDeleteInbound.value = false
			setTimeout(() => {
				autodefineLastTransportForAMaterial(ev.materialRowId)
			}, 300)
			dialogDeleteTransportMaterialRowId.value = null
			dialogDeleteTransportIndex.value = null
			showDialogDeleteTransport.value = false
		})
	} else {
		apiClient.deleteInboundFromTable(inboundTransportList.value[index]).then((res) => {
			inboundTransportList.value[index].distance = null
			inboundTransportList.value[index].isEditable = false
			inboundTransportList.value[index].lastOne = true
			inboundTransportList.value[index].modeOfTransport = ""
			inboundTransportList.value[index].modeOfTransportId = null
			inboundTransportList.value[index].unitId = null
			inboundTransportList.value[index].unitName = ""
			inboundTransportList.value[index].id = self.crypto.randomUUID()
			inboundTransportList.value[index].materialRowId = inboundTransportList.value[index - 1].materialRowId
			inboundTransportList.value[index].isTitle = false
			inboundTransportList.value[index].isNew = true
			inboundTransportList.value[index].isIntermediate = inboundTransportList.value[index - 1].isIntermediate
			inboundTransportList.value[index].materialId = inboundTransportList.value[index - 1].materialId
			inboundTransportList.value[index].intermediateStepId = inboundTransportList.value[index - 1].intermediateStepId
			canDeleteInbound.value = false
			autodefineLastTransportForAMaterial(ev.materialRowId)
			dialogDeleteTransportMaterialRowId.value = null
			dialogDeleteTransportIndex.value = null
			showDialogDeleteTransport.value = false
		})
	}
}
function autodefineLastTransportForAMaterial(materialRowId: string) {
	var selectedInbounds = inboundTransportList.value.filter((item: any) => item.materialRowId === materialRowId)
	var counted = 0
	inboundTransportList.value.forEach((item: any) => {
		if (item.materialRowId === materialRowId) {
			counted++
			if (counted === selectedInbounds.length) {
				item.lastOne = true
			}
		}
	})
}
const materialTableRef = ref<DataTable>(null)
//BIG MATERIALS

function addMaterial(numberOfLines: number) {
	for (var i = 0; i < numberOfLines; i++) {
		let singleRow = new RawMaterialTableRow()
		singleRow.id = self.crypto.randomUUID()
		singleRow.isNew = true
		singleRow.materialId = null
		singleRow.intermediateId = null
		singleRow.isIntermediate = false
		singleRow.isAPIProxy = false
		singleRow.materialName = ""
		singleRow.materialTypeName = ""
		singleRow.materialTypeId = null
		singleRow.cas = ""
		singleRow.quantity = 0
		singleRow.unitId = null
		singleRow.unitName = ""
		singleRow.unitOperationId =
			props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value ? actualUnitOperationId.value : null
		singleRow.unitOperationName = ""
		singleRow.carbonFootprint = 0
		singleRow.dataQualityRatingId = null
		singleRow.dataQualityRatingName = ""
		singleRow.supplierName = ""
		singleRow.supplierLocation = ""
		singleRow.materials = props.tabName === tabsDefinitions.distribution.value ? materials.value : null
		// For Packaging/Distribution tabs, include generalInformationId for proper filtering
		if (props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value) {
			singleRow.generalInformationId = actualGeneralInformation.value
		}

		rawMaterialEntries.value.push(singleRow as RawMaterialTableRow)

		singleRow.referenceQuantity = subTabsDefinitions.deviceMaterials.value.id === "11b05cc3-a137-4e55-ac1a-3857bc54f2f6" ? lifeTimeRef.value : null
	}

	var numNewRows = rawMaterialEntries.value.filter((item: any) => item.isNew == true).length

	var line = rawMaterialEntries.value.length - numberOfLines - 1

	if (numNewRows > 0) {
		//var lineString = line.toString()
		if (line % paginatorForDatatable.value.rows === 9) {
			firstRowOfPage.value = line + 1
			paginatorForDatatable.value.page += 1
			scrollToMatrialTable()
		} else {
		}
	}
}

// function addMaterial(numberOfLines: number) {
// 	for (var i = 0; i < numberOfLines; i++) {
// 		let singleRow = new RawMaterialTableRow()
// 		singleRow.id = self.crypto.randomUUID()
// 		singleRow.isNew = true
// 		singleRow.materialId = null
// 		singleRow.intermediateId = null
// 		singleRow.isIntermediate = false
// 		singleRow.isAPIProxy = false
// 		singleRow.materialName = ""
// 		singleRow.materialTypeName = ""
// 		singleRow.materialTypeId = null
// 		singleRow.cas = ""
// 		singleRow.quantity = 0
// 		singleRow.unitId = null
// 		singleRow.unitName = ""
// 		singleRow.unitOperationId =
// 			props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value ? actualUnitOperationId.value : null
// 		singleRow.unitOperationName = ""
// 		singleRow.carbonFootprint = 0
// 		singleRow.dataQualityRatingId = null
// 		singleRow.dataQualityRatingName = ""
// 		singleRow.supplierName = ""
// 		singleRow.supplierLocation = ""
// 		singleRow.materials = props.tabName === tabsDefinitions.distribution.value ? materials.value : null
// 		singleRow.referenceQuantity = subTabsDefinitions.deviceMaterials.value.id === "11b05cc3-a137-4e55-ac1a-3857bc54f2f6" ? lifeTimeRef.value : null
// 		rawMaterialEntries.value.push(singleRow as RawMaterialTableRow)
// 	}

// 	// var numNewRows = rawMaterialEntries.value.filter((item: any) => item.isNew == true).length

// 	// var line = rawMaterialEntries.value.length - numberOfLines - 1

// 	// var rowsPerPage = paginatorForDatatable.value.rows
// 	// var numOfMaterials = rawMaterialEntries.value.length

// 	// const totalPages = Math.ceil(numOfMaterials / rowsPerPage)

// 	// tablePaginator.page = totalPages - 1

// 	// scrollToMatrialTable()
// 	nextTick(() => {
// 		const tableBody = materialTableRef.value.$el.querySelector(".p-datatable-scrollable-table")
// 		if (tableBody) {
// 			tableBody.scrollTop = tableBody.scrollHeight
// 		}
// 	})

// 	//selectedRow.value = rawMaterialEntries.value.length - 1

// 	// if (numNewRows > 0) {
// 	// 	//var lineString = line.toString()
// 	// 	if (line % paginatorForDatatable.value.rows === 9) {
// 	// 		tablePagFirst.value = line + 1
// 	// 		paginatorForDatatable.value.page += 1
// 	// 		tablePaginator.page += 1
// 	// 		scrollToMatrialTable()
// 	// 	}
// 	// }
// 	//goToLastPage()
// }
// const goToLastPage = () => {
// 	const materialTableRef = ref(null)
// 	if (materialTableRef.value) {
// 		const totalPages = Math.ceil(rawMaterialEntries.value.length / tablePaginator.rows)
// 		materialTableRef.value.setPage(totalPages - 1)
// 	}
// }
//calculate Reference quantity
function calculateReferenceQuantity(data: any, index: number) {
	apiClient.getSingleMaterialReferenceQuantityForRawMaterialTable(actualGeneralInformation.value, data).then((res) => {
		rawMaterialEntries.value[index].referenceQuantity = res
	})
}
function checkNumberOfEntriesThenMoveNextPage(event: any) {}
function unitToKg(type: string): number {
	switch (type) {
		case "kg":
			return 1
		case "g":
			return 1000
		case "mg":
			return 1000000
		case "ug":
			return 1000000000
	}
	return 1
}

// Helper function to convert volume to mass using density
function convertVolumeToMass(quantity: number, volumeUnit: any, density: number | undefined): number {
	// 1 kg/L = 1000 kg/m³ is used as fallback when density is not configured
	const effectiveDensity = !density || density === 0 ? 1000 : density

	// convertToStandardMultiplier converts to m³ (base unit for Volume)
	const volumeInCubicMeters = quantity * (volumeUnit?.convertToStandardMultiplier ?? 1)

	// Calculate mass in kg (density is in kg/m³)
	const massInKg = volumeInCubicMeters * effectiveDensity

	return massInKg
}

function shouldShowRedXForMissingDensity(data: any): boolean {
	// Find unit by unitId like in calcCFPMaterials
	const unit = data.unitId !== null ? findUnitById(data.unitId) : null
	if (unit && unit.unitType && unit.unitType.unitTypeName === "Volume") {
		const density = data.density
		return !density || density <= 0
	}
	return false
}

async function calcCFPMaterials(data: any, index: number): Promise<number | null> {
	// Skip calculation for intermediates - they don't have climate change data
	if (data.isIntermediate) {
		return null
	}

	// Backend now handles all calculations: quantity, unit conversions, density, pallet reuse
	if (data.id !== getEmptyGuid()) {
		return apiClient.getClimateChangeByMaterialEntryId(data.id).then(
			(climateChange) => {
				return climateChange
			},
			(error) => {
				console.error("Failed to calculate carbon footprint:", error)
				useErrorToaster(error)
				return null
			}
		)
	} else {
		return null
	}
}

function changeMaterial(type: String, ev: any, data: any) {
	// const totalPages = Math.ceil(rawMaterialEntries.value.length / paginatorForDatatable.value.rows) - 1
	// //index = (paginatorForDatatable.value.page - 1) * 10 + index
	// index = totalPages * paginatorForDatatable.value.rows + index

	let index = rawMaterialEntries.value.findIndex((item: any) => item.id === data.id)

	switch (type) {
		case "packagingType":
			calculateReferenceQuantity(rawMaterialEntries.value[index], index)
			break
		case "componentName":
			break
		case "materialSubType":
			changeMaterialSubType(index, ev)
			break
		case "materialType":
			changeMaterialType(index, ev)
			break
		case "materialName":
			changeMaterialName(index, ev)
			break
		case "cas":
			changeCAS(index, ev)
			break
		case "unit":
			changeUnit(index, ev)
			break
		case "quantity":
			changeQuantity(index)
			break
		case "unitOperation":
			rawMaterialEntries.value[index].unitOperationId = ev.value
			break
	}
	//setting basic material infos

	rawMaterialEntries.value[index].stepId = actualStepId.value
	rawMaterialEntries.value[index].rawMaterialId = actualRawMaterialId.value
	rawMaterialEntries.value[index].isActive = true
	// For Packaging/Distribution tabs, ensure generalInformationId is set for proper totalMass calculation
	if (props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value) {
		rawMaterialEntries.value[index].generalInformationId = actualGeneralInformation.value
	}

	nextTick()
	// setTimeout(() => {
	saveMaterialInDb(type, index)
	// }, 3000)
}

const saveMaterialInDb = async (type: String, index: number) => {
	let materialNotAllowedToHaveTransport = [
		"Tap water",
		"Tap water (cleaning)",
		"WFI",
		"WFI (cleaning)",
		"Water for injection",
		"Water for injection (cleaning)",
	]
	// return new Promise((resolve, reject) => {
	if (checkIfMaterialCanBeSaved(index)) {
		apiClient.putSingleMaterialFromTable(rawMaterialEntries.value[index]).then((res) => {
			if (res === null) {
				useToaster({
					severity: "error",
					summary: "Error",
					detail: "An error occurred while saving the material. Please try again.",
				})
				return
			} else {
				if (tabsDefinitions.distribution.value === props.tabName) distTotalMassIncludingDownstream.value = res.totalMass!
				EventBus.emit("checkIfEnableConsumerEndOfLifeTab")
				//if (props.tabName === tabsDefinitions.distribution.value || props.tabName === tabsDefinitions.packaging.value)
				EventBus.emit("checkIfResultNeedToBeEnabled_" + props.tabId, props.assessmentId)
				removeBackgroundRowMaterialsForSpecificLine(index)

				if (!res.singleRow) {
					useToaster({
						severity: "error",
						summary: "Error",
						detail: "An error occurred while saving the material.",
					})
					return
				}

				// If the backend assigned a new id (type conversion), update the row id and
				// sync any inbound transport entries that reference the old id before cleanup runs.
				const oldId = rawMaterialEntries.value[index].id
				rawMaterialEntries.value[index].id = res.singleRow.id
				rawMaterialEntries.value[index].createdTimeStamp = res.singleRow.createdTimeStamp
				if (oldId !== res.singleRow.id) {
					inboundTransportList.value
						.filter((t: any) => t.materialRowId === oldId)
						.forEach((t: any) => {
							t.materialRowId = res.singleRow!.id
						})
				}

				if (rawMaterialEntries.value[index].isNew) {
					compileTransportForNewMaterial(index, materialNotAllowedToHaveTransport)
				} else {
					cleanupTransportAndUpdateItByDb(index, materialNotAllowedToHaveTransport, type)
				}

				emit("materialAdded", res.singleRow)

				// Calculate carbon footprint after material is saved to database
				calcCFPMaterials(rawMaterialEntries.value[index], index).then((cfp) => {
					rawMaterialEntries.value[index].carbonFootprint = cfp
				})

				useToaster({
					severity: "success",
					summary: "Success",
					detail: "Material saved successfully",
					life: 3000,
				})
				generateProcessWaste()
			}
		})
	} else {
		if (rawMaterialEntries.value[index] && !rawMaterialEntries.value[index].isNew) {
			useToaster({
				severity: "error",
				summary: "Error",
				detail: "Please fill all required fields before saving the material.",
			})
		}
	}
	// })
}

function cleanupTransportAndUpdateItByDb(index: number, materialNotAllowedToHaveTransport: string[], type: String) {
	if (materialNotAllowedToHaveTransport.indexOf(rawMaterialEntries.value[index].materialName) !== -1) {
		//remove not allowed water materials from inbuond

		var inboundToDelete = inboundTransportList.value.filter(
			(item: any) => item.materialRowId === rawMaterialEntries.value[index].id && item.isTitle == false
		)

		inboundTransportList.value = inboundTransportList.value.filter((item: any) => item.materialRowId !== rawMaterialEntries.value[index].id)
		inboundToDelete.forEach((el: any) => {
			apiClient.deleteInboundFromTableById(el.id).then((res) => {
				inboundTransportList.value = inboundTransportList.value.filter((item: any) => item.materialRowId !== rawMaterialEntries.value[index].id)
			})
		})
	} else {
		//if not change transport materialId only if change the material in row material table
		if (type === "materialName" || type === "cas") {
			if (rawMaterialEntries.value[index].materialTypeName === "Water") {
				var transportMatList = inboundTransportList.value.filter((item: any) => item.materialRowId === rawMaterialEntries.value[index].id)
				if (transportMatList.length === 0) {
					var newEmptyObj = new InboundTransportForMaterials()
					newEmptyObj.materialId = rawMaterialEntries.value[index].materialId
					newEmptyObj.materialName = rawMaterialEntries.value[index].materialName
					newEmptyObj.isIntermediate = rawMaterialEntries.value[index].isIntermediate
					newEmptyObj.intermediateStepId = rawMaterialEntries.value[index].intermediateStepId
					newEmptyObj.isTitle = true
					newEmptyObj.materialRowId = rawMaterialEntries.value[index].id
					newEmptyObj.id = self.crypto.randomUUID()
					inboundTransportList.value.push(newEmptyObj)
					apiClient.getDefaultTransport().then((res) => {
						res.forEach((single) => {
							var newEmptyObj = new InboundTransportForMaterials()
							newEmptyObj.materialId = !rawMaterialEntries.value[index].isIntermediate ? rawMaterialEntries.value[index].materialId : null
							newEmptyObj.id = self.crypto.randomUUID()
							newEmptyObj.intermediateStepId = rawMaterialEntries.value[index].isIntermediate
								? rawMaterialEntries.value[index].intermediateStepId
								: null
							newEmptyObj.materialName = ""
							newEmptyObj.rawMaterialId = actualRawMaterialId.value
							newEmptyObj.stepId = actualStepId.value
							newEmptyObj.modeOfTransportId = single.modeOfTransportId
							newEmptyObj.distance = single.distance
							newEmptyObj.unitId = single.unitId
							newEmptyObj.isEditable = true
							newEmptyObj.isTitle = false
							newEmptyObj.lastOne = true
							newEmptyObj.isIntermediate = rawMaterialEntries.value[index].isIntermediate
							newEmptyObj.isNew = true
							newEmptyObj.materialRowId = rawMaterialEntries.value[index].id
							newEmptyObj.isAPIProxy = rawMaterialEntries.value[index].isAPIProxy

							inboundTransportList.value.push(newEmptyObj)
							apiClient.postSingleInboundTransportFromTable(newEmptyObj).then((res) => {
								rawMaterialEntries.value[index].isNew = false
							})
						})
					})
				} else {
					var findAllOccurrenceOfAMaterialInTransport = inboundTransportList.value.filter(
						(item: any) => item.materialRowId === rawMaterialEntries.value[index].id && item.isTitle === false
					)
					var findTransportTitle = inboundTransportList.value.find(
						(item: any) => item.materialRowId === rawMaterialEntries.value[index].id && item.isTitle === true
					)

					if (findTransportTitle !== undefined) {
						findTransportTitle.materialId = rawMaterialEntries.value[index].materialId
						findTransportTitle.materialName = rawMaterialEntries.value[index].materialName
						if (findTransportTitle.allTransportsForMaterial !== undefined)
							findTransportTitle.allTransportsForMaterial.forEach((single: any) => {
								single.materialId = rawMaterialEntries.value[index].materialId
							})
					}
					findAllOccurrenceOfAMaterialInTransport.forEach((single: any) => {
						single.rawMaterialId = actualRawMaterialId.value
						single.stepId = actualStepId.value

						if (single.isTitle === false) apiClient.postSingleInboundTransportFromTable(single).then((res) => {})
					})
				}
			} else {
				var findAllOccurrenceOfAMaterialInTransport = inboundTransportList.value.filter(
					(item: any) => item.materialRowId === rawMaterialEntries.value[index].id && item.isTitle === false
				)
				var findTransportTitle = inboundTransportList.value.find(
					(item: any) => item.materialRowId === rawMaterialEntries.value[index].id && item.isTitle === true
				)

				if (findTransportTitle !== undefined) {
					findTransportTitle.materialId = rawMaterialEntries.value[index].materialId
					findTransportTitle.materialName = rawMaterialEntries.value[index].materialName
					if (findTransportTitle.allTransportsForMaterial !== undefined)
						findTransportTitle.allTransportsForMaterial.forEach((single: any) => {
							single.materialId = rawMaterialEntries.value[index].materialId
						})
				}
				findAllOccurrenceOfAMaterialInTransport.forEach((single: any) => {
					single.rawMaterialId = actualRawMaterialId.value
					single.stepId = actualStepId.value
					if (single.isTitle === false) apiClient.postSingleInboundTransportFromTable(single).then((res) => {})
				})
			}
		}
	}
}

function compileTransportForNewMaterial(index: number, materialNotAllowedToHaveTransport: string[]) {
	if (materialNotAllowedToHaveTransport.indexOf(rawMaterialEntries.value[index].materialName) === -1) {
		var newEmptyObj = new InboundTransportForMaterials()
		var allNewInbounds = [] as InboundTransportForMaterials[]
		newEmptyObj.materialId = rawMaterialEntries.value[index].materialId
		newEmptyObj.materialName = rawMaterialEntries.value[index].materialName
		newEmptyObj.isIntermediate = rawMaterialEntries.value[index].isIntermediate
		newEmptyObj.intermediateStepId = rawMaterialEntries.value[index].intermediateStepId
		newEmptyObj.isTitle = true
		newEmptyObj.materialRowId = rawMaterialEntries.value[index].id
		newEmptyObj.id = self.crypto.randomUUID()
		inboundTransportList.value.push(newEmptyObj)
		apiClient
			.getDefaultTransport()
			.then((res) => {
				res.forEach((single) => {
					var newEmptyObj = new InboundTransportForMaterials()
					newEmptyObj.materialId = !rawMaterialEntries.value[index].isIntermediate ? rawMaterialEntries.value[index].materialId : null
					newEmptyObj.id = self.crypto.randomUUID()
					newEmptyObj.intermediateStepId = rawMaterialEntries.value[index].isIntermediate ? rawMaterialEntries.value[index].intermediateStepId : null
					newEmptyObj.materialName = ""
					newEmptyObj.rawMaterialId = actualRawMaterialId.value
					newEmptyObj.stepId = actualStepId.value
					newEmptyObj.modeOfTransportId = single.modeOfTransportId
					newEmptyObj.distance = single.distance
					newEmptyObj.unitId = single.unitId
					newEmptyObj.isEditable = true
					newEmptyObj.isTitle = false
					newEmptyObj.lastOne = true
					newEmptyObj.isAPIProxy = rawMaterialEntries.value[index].isAPIProxy
					newEmptyObj.isIntermediate = rawMaterialEntries.value[index].isIntermediate
					newEmptyObj.isNew = true
					newEmptyObj.materialRowId = rawMaterialEntries.value[index].id

					allNewInbounds.push(newEmptyObj)
				})
				nextTick()
				return allNewInbounds
			})
			.then((inbounds) => {
				inbounds.forEach((singleIn) => {
					apiClient.postSingleInboundTransportFromTable(singleIn).then((res) => {
						rawMaterialEntries.value[index].isNew = false
						inboundTransportList.value.push(res)
					})
				})
			})
	} else {
	}
}
//transport functions
function changeTransport(type: String, ev: any, index: any) {
	switch (type) {
		case "modeOfTransport":
			break
	}
	inboundTransportList.value[index].rawMaterialId = actualRawMaterialId.value
	inboundTransportList.value[index].stepId = actualStepId.value

	if (
		inboundTransportList.value[index].modeOfTransportId !== null &&
		(inboundTransportList.value[index].distance !== null || inboundTransportList.value[index].distace !== 0) &&
		inboundTransportList.value[index].unitId !== null
	) {
		apiClient.postSingleInboundTransportFromTable(inboundTransportList.value[index]).then(
			(res) => {
				useToaster({
					severity: "success",
					summary: "Success",
					detail: "Transport updated successfully",
					life: 3000,
				})
			},
			(err) => {
				useErrorToaster(err.response)
			}
		)
	}
}
const canDeleteInbound = ref(true)

function applyDefaultTransportDialog() {
	dialogDefaultConfirmation.value = true
}
function addTransport(ev: any, index: any) {
	inboundTransportList.value[index].lastOne = false

	var indexMainLine = ev.isIntermediate
		? inboundTransportList.value.findIndex((item: any) => item.intermediateStepId == ev.intermediateStepId && item.isTitle == true)
		: inboundTransportList.value.findIndex((item: any) => item.materialId == ev.materialId && item.isTitle == true)

	var newEmptyObj = new InboundTransportForMaterials()
	newEmptyObj.materialId = ev.materialId
	newEmptyObj.intermediateStepId = ev.intermediateStepId
	newEmptyObj.isAPIProxy = ev.isAPIProxy
	newEmptyObj.materialName = ""
	newEmptyObj.modeOfTransportId = null
	newEmptyObj.distance = null
	newEmptyObj.unitId = null
	newEmptyObj.isEditable = true
	newEmptyObj.isNew = true
	newEmptyObj.id = self.crypto.randomUUID()
	newEmptyObj.isIntermediate = ev.isIntermediate
	newEmptyObj.lastOne = true
	newEmptyObj.isTitle = false
	newEmptyObj.materialRowId = ev.materialRowId
	inboundTransportList.value.splice(index + 1, 0, newEmptyObj)
}
function removeAddedTransport(ev: any, index: number) {
	dialogDeleteTransportMaterialRowId.value = ev
	dialogDeleteTransportIndex.value = index
	showDialogDeleteTransport.value = true
}
function applyDefaultTransport() {
	let materialNotAllowedToHaveTransport = ["Tap water", "Tap water (cleaning)", "WFI", "WFI (cleaning)"]
	apiClient
		.removeAllTransportForMaterialsByTransportIds(
			inboundTransportList.value.filter((inbound) => inbound.hasOwnProperty("id") && inbound.id != null).map((obj: any) => obj.id)
		)
		.then(
			(res) => {
				inboundTransportList.value = []
				apiClient.getDefaultEntries("transportMaterialDefault").then((res) => {
					let defaultValues = JSON.parse(res.defaultJsonData)

					rawMaterialEntries.value.forEach((el: any) => {
						if (materialNotAllowedToHaveTransport.indexOf(el.materialName) === -1) {
							var isInlist = inboundTransportList.value.filter((item: any) => item.materialRowId === el.id)
							if (isInlist.length == 0) {
								inboundTransportList.value.push({
									materialId: el.materialTypeName != "Intermediates" ? el.materialId : null,
									intermediateStepId: el.materialTypeName == "Intermediates" ? el.materialId : null,
									materialName: el.materialName,
									modeOfTransport: "",
									distance: "",
									unit: "",
									isEditable: false,
									numOfInbound: defaultValues.length,
									isTitle: true,
									isIntermediate: el.materialTypeName == "Intermediates" ? true : false,
									materialRowId: el.id,
									id: self.crypto.randomUUID(),
								})

								defaultValues.forEach((singleValue: any, index: number) => {
									//65643
									var newEmptyObj = new InboundTransportForMaterials({
										id: self.crypto.randomUUID(),

										materialId: el.materialTypeName != "Intermediates" ? el.materialId : null,
										intermediateStepId: el.materialTypeName == "Intermediates" ? el.materialId : null,
										materialName: "",
										modeOfTransportId: singleValue.modeOfTransportId.toLowerCase(),
										modeOfTransport: singleValue.transportName,
										distance: singleValue.distance,
										unitId: singleValue.unitId.toLowerCase(),
										unitName: singleValue.unitName,
										isEditable: true,
										isIntermediate: el.materialTypeName == "Intermediates" ? true : false,
										isAPIProxy: el.isAPIProxy,
										isNew: false,
										materialRowId: el.id,
										lastOne: index === defaultValues.length - 1 ? true : false,
										isTitle: false,
										rawMaterialId: actualRawMaterialId.value,
										stepId: actualStepId.value,
									})

									inboundTransportList.value.push(newEmptyObj)
									apiClient.postSingleInboundTransportFromTable(newEmptyObj).then((res) => {
										rawMaterialEntries.value[index].isNew = false
									})
								})
							}
						}
					})
					dialogDefaultConfirmation.value = false
				})
			},
			(err) => {
				useErrorToaster(err.response)
			}
		)
}
function removeBackgroundRowMaterialsForSpecificLine(line: number) {
	var rootElement = document.getElementById("dtRawMaterialList_" + props.tabId)
	if (rootElement) {
		var childElement = rootElement.querySelectorAll(".p-datatable-wrapper table .p-datatable-tbody")
		if (childElement.length > 0) {
			for (var i = 0; i < childElement[0].children.length; i++) {
				if (i == line) childElement[0].children[i].classList.remove("p-datatable-row-selected")
			}
		}
	}
	//check things to do
	var numNewRows = rawMaterialEntries.value.filter((item: any) => item.isNew == true).length
	if (numNewRows > 0) {
		//var lineString = line.toString()
		if (line % 10 === 9 && rawMaterialEntries.value[line].quantity !== 0) {
			firstRowOfPage.value = line + 1
			paginatorForDatatable.value.page += 1
			scrollToMatrialTable()
		}
	}
}

function scrollToMatrialTable() {
	const element = document.getElementById("dtRawMaterialList_" + props.tabId)
	if (element) {
		element.scrollIntoView({ behavior: "smooth" })
	}
}
function checkIfMaterialCanBeSaved(index: number): boolean {
	var checkIfCanBeSaved = false
	if (!rawMaterialEntries.value[index]) return false
	//check per screen type
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			checkIfCanBeSaved =
				rawMaterialEntries.value[index].materialId !== null &&
				rawMaterialEntries.value[index].unitId !== null &&
				rawMaterialEntries.value[index].quantity !== 0 &&
				rawMaterialEntries.value[index].quantity !== null &&
				rawMaterialEntries.value[index].quantity !== "" &&
				// Unit operation is required if user has selected any unit operations in the main form
				(isUnitOperationRequired.value
					? rawMaterialEntries.value[index].unitOperationId !== undefined && rawMaterialEntries.value[index].unitOperationId !== null
					: true)

			break
		case tabsDefinitions.packaging.value:
			if (props.subTabName === subTabsDefinitions.deviceMaterials.value.label) {
				checkIfCanBeSaved =
					rawMaterialEntries.value[index].materialId !== null &&
					rawMaterialEntries.value[index].unitId !== null &&
					rawMaterialEntries.value[index].componentName !== undefined &&
					rawMaterialEntries.value[index].componentName !== "" &&
					rawMaterialEntries.value[index].quantity !== 0 &&
					rawMaterialEntries.value[index].quantity !== null &&
					rawMaterialEntries.value[index].quantity !== ""
			} else {
				checkIfCanBeSaved =
					rawMaterialEntries.value[index].materialId !== null &&
					rawMaterialEntries.value[index].unitId !== null &&
					rawMaterialEntries.value[index].componentName !== undefined &&
					rawMaterialEntries.value[index].componentName !== "" &&
					rawMaterialEntries.value[index].packagingTypeId !== null &&
					rawMaterialEntries.value[index].packagingTypeId !== undefined &&
					rawMaterialEntries.value[index].quantity !== 0 &&
					rawMaterialEntries.value[index].quantity !== null &&
					rawMaterialEntries.value[index].quantity !== ""
			}

			break
		case tabsDefinitions.distribution.value:
			checkIfCanBeSaved =
				rawMaterialEntries.value[index].materialId !== null &&
				rawMaterialEntries.value[index].unitId !== null &&
				rawMaterialEntries.value[index].quantity !== 0 &&
				rawMaterialEntries.value[index].quantity !== null &&
				rawMaterialEntries.value[index].quantity !== ""
			break
		default:
			checkIfCanBeSaved =
				rawMaterialEntries.value[index].materialId !== null &&
				rawMaterialEntries.value[index].unitId !== null &&
				// Unit operation is required if user has selected any unit operations in the main form
				(!isUnitOperationRequired.value || rawMaterialEntries.value[index].unitOperationId !== null) &&
				rawMaterialEntries.value[index].quantity !== 0 &&
				rawMaterialEntries.value[index].quantity !== null &&
				rawMaterialEntries.value[index].quantity !== ""
			break
	}
	return checkIfCanBeSaved
}

async function changeQuantity(index: number) {
	if (rawMaterialEntries.value[index].materialTypeName !== "Intermediates") {
		let number = parseFloat(rawMaterialEntries.value[index].quantity)
		if (!isFinite(number)) rawMaterialEntries.value[index].quantity = 0
		if (number && number < 1e-6) {
			rawMaterialEntries.value[index].quantity = number.toFixed(8)
		}

		// Only calculate carbon footprint if both quantity and unit are filled in
		// if (checkIfMaterialCanBeSaved(index)) {
		// 	if (rawMaterialEntries.value[index].id !== getEmptyGuid()) {
		// 		rawMaterialEntries.value[index].carbonFootprint = await calcCFPMaterials(rawMaterialEntries.value[index], index)
		// 	}
		// }
	}
}

// Helper function to find unit by id in all unit arrays
const findUnitById = (unitId: string) => {
	// Check in weight units
	const weightUnit = unitsWeight.value?.find((item: any) => item.id === unitId)
	if (weightUnit) return weightUnit

	// Check in volume units
	const volumeUnit = unitsVolume.value?.find((item: any) => item.id === unitId)
	if (volumeUnit) return volumeUnit

	// Check in consumable units
	const consumableUnit = unitsConsumables.value?.find((item: any) => item.id === unitId)
	if (consumableUnit) return consumableUnit

	// Check in distance units
	const distanceUnit = unitsDistance.value?.find((item: any) => item.id === unitId)
	if (distanceUnit) return distanceUnit

	return null
}

// Helper function to check if any entry uses volume units and update warning
const checkVolumeUnitsUsage = () => {
	let hasVolumeUnits = false

	for (let entry of rawMaterialEntries.value) {
		if (entry.unitId) {
			const unit = findUnitById(entry.unitId)
			if (unit && unit.unitType && unit.unitType.unitTypeName === "Volume") {
				hasVolumeUnits = true
				break
			}
		}
	}

	showVolumeWarning.value = hasVolumeUnits
}

// Helper function to check if a material has a volume unit with missing density
const isVolumeUnitWithMissingDensity = (data: any) => {
	if (!data.unitId || (data.density !== 0 && data.density !== null && data.density !== undefined)) {
		return false
	}

	const unit = findUnitById(data.unitId)

	return unit && unit.unitType && unit.unitType.unitTypeName === "Volume"
}

async function changeUnit(index: number, ev: any) {
	const entry = rawMaterialEntries.value[index]
	if (!entry) return

	if (entry.materialTypeName === "Consumables") {
		entry.unitName = "Piece(s)"
	} else {
		const unit = findUnitById(ev.value)
		if (unit) {
			entry.unitName = unit.unitName
		} else {
			console.error(`Unit with id ${ev.value} not found`)
			entry.unitName = ""
		}
	}
	// Only calculate carbon footprint if all required fields are filled
	if (checkIfMaterialCanBeSaved(index)) {
		entry.carbonFootprint = await calcCFPMaterials(entry, index)
	}
	checkVolumeUnitsUsage()
}

async function changeCAS(index: number, ev: any) {
	let materialNotAllowedToHaveTransport = ["Tap water", "Tap water (cleaning)", "WFI", "WFI (cleaning)"]
	let materialTypeId = materials.value.filter((item: any) => item.id === rawMaterialEntries.value[index].materialId)[0].materialTypeId

	rawMaterialEntries.value[index].materialTypeId = materialTypeId
	//change material type
	rawMaterialEntries.value[index].materials = materials.value.filter((item: any) => item.materialTypeId == materialTypeId)
	rawMaterialEntries.value[index].materialTypeName = materialTypes.value.filter((item: any) => item.id == materialTypeId)[0].materialTypeName
	if (materialTypes.value.filter((item: any) => item.id == materialTypeId)[0].materialTypeName === "Intermediates") {
		rawMaterialEntries.value[index].isIntermediate = true
	} else {
		rawMaterialEntries.value[index].isIntermediate = false
	}
	setTimeout(() => {
		if (materialTypes.value.filter((item: any) => item.id == materialTypeId)[0].materialTypeName === "Consumables") {
			rawMaterialEntries.value[index].unitName = "Piece(s)"
			rawMaterialEntries.value[index].unitId = unitsConsumables.value[0].id
		} else {
			if (props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value) {
				rawMaterialEntries.value[index].unitName = unitsWeight.value.filter((item: any) => item.id === selectedUnit.value)[0].unitName
				rawMaterialEntries.value[index].unitId = unitsWeight.value.filter((item: any) => item.id === selectedUnit.value)[0].id
			} else {
				rawMaterialEntries.value[index].unitName = "kg"
				rawMaterialEntries.value[index].unitId = unitsWeight.value[1].id
			}
		}
		checkVolumeUnitsUsage()
	}, 500)
	// material name
	rawMaterialEntries.value[index].dataQualityScore =
		materials.value.filter((item: any) => item.id == ev.value)[0] === undefined
			? 0
			: materials.value.filter((item: any) => item.id == ev.value)[0].dataQualityScore
	rawMaterialEntries.value[index].materialName =
		materials.value.filter((item: any) => item.id == ev.value)[0] === undefined
			? 0
			: materials.value.filter((item: any) => item.id == ev.value)[0].materialName
	if (
		materialTypes.value.find((item: any) => {
			return item.id === rawMaterialEntries.value[index].materialTypeId
		}).materialTypeName !== "Intermediates"
	) {
		// Only calculate carbon footprint if all required fields are filled
		if (checkIfMaterialCanBeSaved(index)) {
			rawMaterialEntries.value[index].carbonFootprint = await calcCFPMaterials(rawMaterialEntries.value[index], index)
		}
		rawMaterialEntries.value[index].isIntermediate = false
	} else {
		rawMaterialEntries.value[index].isIntermediate = true
	}
	//update inbound
	if (materialNotAllowedToHaveTransport.indexOf(rawMaterialEntries.value[index].materialName) === -1) {
		var checkIfIsInInbound = inboundTransportList.value.filter((item: any) => item.materialRowId === rawMaterialEntries.value[index].id)
		if (checkIfIsInInbound.length === 0) rawMaterialEntries.value[index].isNew = true
	}
}

async function changeMaterialName(index: number, ev: any) {
	let materialNotAllowedToHaveTransport = ["Tap water", "Tap water (cleaning)", "WFI", "WFI (cleaning)"]
	rawMaterialEntries.value[index].cas =
		materials.value.filter((item: any) => item.id == ev.value)[0] === undefined
			? ""
			: materials.value.filter((item: any) => item.id == ev.value)[0].cas
	rawMaterialEntries.value[index].dataQualityScore =
		materials.value.filter((item: any) => item.id == ev.value)[0] === undefined
			? 0
			: materials.value.filter((item: any) => item.id == ev.value)[0].dataQualityScore
	rawMaterialEntries.value[index].materialName =
		materials.value.filter((item: any) => item.id == ev.value)[0] === undefined
			? 0
			: materials.value.filter((item: any) => item.id == ev.value)[0].materialName
	if (props.tabName !== tabsDefinitions.packaging.value && props.tabName !== tabsDefinitions.distribution.value) {
		if (
			materialTypes.value.find((item: any) => {
				return item.id === rawMaterialEntries.value[index].materialTypeId
			}).materialTypeName !== "Intermediates"
		) {
			// Only calculate carbon footprint if all required fields are filled
			if (checkIfMaterialCanBeSaved(index)) {
				rawMaterialEntries.value[index].carbonFootprint = await calcCFPMaterials(rawMaterialEntries.value[index], index)
			}
			rawMaterialEntries.value[index].isIntermediate = false
		} else {
			rawMaterialEntries.value[index].isIntermediate = true
		}
	} else {
		rawMaterialEntries.value[index].isIntermediate = false
	}

	if (rawMaterialEntries.value[index].materialSubTypeName !== "Others" && props.tabName === tabsDefinitions.distribution.value) {
		rawMaterialEntries.value[index].unitName = "Piece(s)"
		rawMaterialEntries.value[index].unitId = unitsConsumables.value[0].id
	}

	if (materialNotAllowedToHaveTransport.indexOf(rawMaterialEntries.value[index].materialName) === -1) {
		var checkIfIsInInbound = inboundTransportList.value.filter((item: any) => item.materialRowId === rawMaterialEntries.value[index].id)
		if (checkIfIsInInbound.length > 0) {
			checkIfIsInInbound[0].materialName = rawMaterialEntries.value[index].materialName
			checkIfIsInInbound[0].materialId = rawMaterialEntries.value[index].materialId
			checkIfIsInInbound[0].materialRowId = rawMaterialEntries.value[index].id
		}
	}

	// Only calculate carbon footprint if all required fields are filled
	if (checkIfMaterialCanBeSaved(index)) {
		rawMaterialEntries.value[index].carbonFootprint = await calcCFPMaterials(rawMaterialEntries.value[index], index)
	}

	// Focus and select quantity input after material selection
	nextTick(() => {
		const dataId = rawMaterialEntries.value[index]?.id
		if (dataId) {
			const quantityInput = document.getElementById(`quantityInput_${dataId}`) as HTMLInputElement
			if (quantityInput) {
				quantityInput.focus()
				quantityInput.select()
			}
		}
	})
}

function changeMaterialType(index: number, ev: any) {
	if (props.tabName === tabsDefinitions.packaging.value) {
		rawMaterialEntries.value[index].materials = materials.value.filter((item: any) => item.materialTypeId == ev.value)
		rawMaterialEntries.value[index].materialTypeName = materialTypes.value.filter((item: any) => item.id == ev.value)[0].materialTypeName
		if (materialTypes.value.filter((item: any) => item.id == ev.value)[0].materialTypeName === "Intermediates") {
			rawMaterialEntries.value[index].isIntermediate = true
		} else {
			rawMaterialEntries.value[index].isIntermediate = false
		}

		setTimeout(() => {
			if (
				materialTypes.value.filter((item: any) => item.id == rawMaterialEntries.value[index].materialTypeId)[0].materialTypeName === "Consumables"
			) {
				rawMaterialEntries.value[index].unitName = "Piece(s)"
				rawMaterialEntries.value[index].unitId = unitsConsumables.value[0].id
			} else {
				if (props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value) {
					rawMaterialEntries.value[index].unitName = unitsWeight.value.filter((item: any) => item.id === selectedUnit.value)[0].unitName
					rawMaterialEntries.value[index].unitId = unitsWeight.value.filter((item: any) => item.id === selectedUnit.value)[0].id
				} else {
					rawMaterialEntries.value[index].unitName = "kg"
					rawMaterialEntries.value[index].unitId = unitsWeight.value[1].id
				}
			}
		}, 500)
		rawMaterialEntries.value[index].materialId = null
	} else {
		rawMaterialEntries.value[index].materials = materials.value.filter((item: any) => item.materialTypeId == ev.value)
		rawMaterialEntries.value[index].materialTypeName = materialTypes.value.filter((item: any) => item.id == ev.value)[0].materialTypeName
		if (materialTypes.value.filter((item: any) => item.id == ev.value)[0].materialTypeName === "Intermediates") {
			rawMaterialEntries.value[index].isIntermediate = true
		} else {
			rawMaterialEntries.value[index].isIntermediate = false
		}
		if (
			rawMaterialEntries.value[index].materialTypeName === "API Synthetic" ||
			rawMaterialEntries.value[index].materialTypeName === "API Biologics"
		) {
			rawMaterialEntries.value[index].isAPIProxy = true
		} else {
			rawMaterialEntries.value[index].isAPIProxy = false
		}
		setTimeout(() => {
			if (
				materialTypes.value.filter((item: any) => item.id == rawMaterialEntries.value[index].materialTypeId)[0].materialTypeName === "Consumables"
			) {
				rawMaterialEntries.value[index].unitName = "Piece(s)"
				rawMaterialEntries.value[index].unitId = unitsConsumables.value[0].id
			} else {
				if (props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value) {
					rawMaterialEntries.value[index].unitName = unitsWeight.value.filter((item: any) => item.id === selectedUnit.value)[0].unitName
					rawMaterialEntries.value[index].unitId = unitsWeight.value.filter((item: any) => item.id === selectedUnit.value)[0].id
				} else {
					rawMaterialEntries.value[index].unitName = "kg"
					rawMaterialEntries.value[index].unitId = unitsWeight.value[1].id
				}
			}
		}, 500)
		rawMaterialEntries.value[index].materialId = null
	}
}

function changeMaterialSubType(index: number, ev: any) {
	rawMaterialEntries.value[index].materials = materials.value.filter((item: any) => item.materialSubTypeId == ev.value)
	rawMaterialEntries.value[index].materialSubTypeName = materialSubTypes.value.filter((item: any) => item.id == ev.value)[0].materialSubTypeName

	rawMaterialEntries.value[index].isIntermediate = false

	setTimeout(() => {
		if (
			tabsDefinitions.distribution.value === props.tabName &&
			materialSubTypes.value.filter((item: any) => item.id == ev.value)[0].materialSubTypeName !== "Others"
		) {
			setTimeout(() => {
				rawMaterialEntries.value[index].unitName = "Piece(s)"
				rawMaterialEntries.value[index].unitId = unitsConsumables.value[0].id
			}, 500)
		} else {
			setTimeout(() => {
				rawMaterialEntries.value[index].unitName = "kg"
				rawMaterialEntries.value[index].unitId = unitsWeight.value[1].id
			}, 500)
		}
	}, 500)

	rawMaterialEntries.value[index].materialId = null
}

function checkMandatoryFiels() {
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			return checkSingleField(massOutput.value) && checkSingleField(selectedUnit.value) && checkSingleField(selectedSite.value)
			break
		case tabsDefinitions.productProcess.value:
			return (
				checkSingleField(productOutputName.value) &&
				checkSingleField(massOutput.value) &&
				checkSingleField(selectedUnit.value) &&
				checkSingleField(selectedSite.value)
			)
			break
	}
	return true
}
function checkSingleField(field: any) {
	return field !== null && field !== "" && field !== undefined
}

function checkListField(field: any) {
	return field.length > 0
}
const isSaving = ref(false)
//save rawmaterial basic info
function saveRawMaterials(showMessage: boolean) {
	if (isSaving.value) return
	isSaving.value = true
	clickOutside()
	progressSaving.value = true
	saveAttempted.value = true
	if (addNewUnitOperation.value) {
		toast.add({
			severity: "error",
			summary: "Close Add new unit Operation Process",
			detail: ``,
			life: 3000,
			group: props.tabId,
		})
		progressSaving.value = false
		isSaving.value = false

		return
	}
	if (!checkMandatoryFiels()) {
		toast.add({
			severity: "error",
			summary: "Missing required fields",
			detail: `Highlighted fields are required`,
			life: 3000,
			group: props.tabId,
		})
		progressSaving.value = false
		isSaving.value = false
		return
	}

	// var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
	// var toGetStatus = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
	// //selectedStepName.value = toGetStatus.actualSubTabName
	actualStepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
	actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
		(item: any) => item.actualMainTabId === props.tabId
	).generalInformationId
	var materialForm = new RawMaterialGlobalData()
	materialForm.unitOperations = selectedUnitOperations.value
	materialForm.rawMaterial = new RawMaterial()
	materialForm.globalUnitOperationId = actualUnitOperationId.value
	materialForm.rawMaterial.id = actualRawMaterialId.value === null ? self.crypto.randomUUID() : actualRawMaterialId.value
	materialForm.rawMaterial.stepId = actualStepId.value
	materialForm.rawMaterial.isActive = true
	materialForm.rawMaterial.massOfProduct = massOutput.value
	materialForm.rawMaterial.note = notes.value
	materialForm.rawMaterial.generalInformationId = actualGeneralInformation.value
	materialForm.rawMaterial.siteLocationId = selectedSite.value
	materialForm.rawMaterial.unitId = selectedUnit.value
	materialForm.rawMaterial.bdsConcentration = concentrationOutput.value
	materialForm.rawMaterial.bdsUnitId = selectedConcentrationUnit.value
	materialForm.rawMaterial.productOutputName = productOutputName.value
	//materialForm.rawMaterialTableRows = rawMaterialEntries.value
	switch (props.subTabName) {
		case subTabsDefinitions.deviceMaterials.value.label:
			materialForm.rawMaterial.rawMaterialType = subTabsDefinitions.deviceMaterials.value.id
			break
		case subTabsDefinitions.packagingMaterials.value.label:
			materialForm.rawMaterial.rawMaterialType = subTabsDefinitions.packagingMaterials.value.id
			break
		default:
			materialForm.rawMaterial.rawMaterialType = null
			break
	}
	//props.tabName === tabsDefinitions.packaging.value ? props.tabName.replace(" ", "") + "|" + props.subTabName.replace(" ", "") : null

	//return
	apiClient
		.putTheMaterialForm(materialForm)
		.then(
			(res) => {
				actualRawMaterialId.value = res.rawMaterial.id
				if (updatedImage.value || deleteTheImage.value === true) {
					submitFile(materialForm.rawMaterial.id).then((res) => {
						if (res) {
							if (showMessage)
								toast.add({
									severity: "success",
									summary: "Raw Materials saved",
									detail: ``,
									life: 3000,
									group: props.tabId,
								})
							selectedRow.value = []
							// After save, update initial state to current state
							initialSelectedUnitOperations.value = [...selectedUnitOperations.value]
							selectableUnitOperations.value = unitOperations.value.filter((item: any) => selectedUnitOperations.value.includes(item.id))

							// Clean up materials with unit operations that are no longer selected
							rawMaterialEntries.value.forEach((material: any) => {
								if (material.unitOperationId && !selectedUnitOperations.value.includes(material.unitOperationId)) {
									material.unitOperationId = null
								}
							})

							updateAssessmentUpdatedByDate(props.assessmentId)
							progressSaving.value = false
							EventBus.emit("nextPrevEnabled_" + props.tabId)
							EventBus.emit("enableTabsAfterRawMaterial" + props.tabId, actualStepId.value)
						}
					})
					updatedImage.value = false
					deleteTheImage.value = false
					isSaving.value = false
					saveAttempted.value = false
				} else {
					if (showMessage) {
						if (saveRawMaterialList(false, true) && saveInboundTransportList(false, true)) {
							toast.add({
								severity: "success",
								summary: "Raw Materials saved",
								detail: ``,
								life: 3000,
								group: props.tabId,
							})
							updateAssessmentUpdatedByDate(props.assessmentId)
						}
						selectedRow.value = []
						// After save, update initial state to current state
						initialSelectedUnitOperations.value = [...selectedUnitOperations.value]
						selectableUnitOperations.value = unitOperations.value.filter((item: any) => selectedUnitOperations.value.includes(item.id))

						// Clean up materials with unit operations that are no longer selected
						rawMaterialEntries.value.forEach((material: any) => {
							if (material.unitOperationId && !selectedUnitOperations.value.includes(material.unitOperationId)) {
								material.unitOperationId = null
							}
						})
					}

					progressSaving.value = false
					EventBus.emit("nextPrevEnabled_" + props.tabId)
					EventBus.emit("enableTabsAfterRawMaterial" + props.tabId, actualStepId.value)
					deleteTheImage.value = false
					isSaving.value = false
					saveAttempted.value = false
				}
				if (res.rawMaterial) emit("rawMaterialUpdated", res.rawMaterial)
			},
			(err) => {
				toast.add({
					severity: "error",
					summary: "Problem saving Raw Materials",
					detail: ``,
					life: 3000,
					group: props.tabId,
				})
				progressSaving.value = false
				deleteTheImage.value = false
				isSaving.value = false
				saveAttempted.value = false
			}
		)
		.then(() => generateProcessWaste())
}

const generateProcessWaste = async () => {
	var region = selectedSite.value ? selectedSite.value : "250D765A-B173-4B56-824E-3BC3FCF58B30"
	try {
		var res = appSettingClient.populateProcessWasteProcess(
			props.assessmentId,
			actualGeneralInformation.value,
			props.tabId,
			actualStepId.value,
			region
		)
	} catch (err) {
		console.error("Connection error:", err)
	}
}

function saveRawMaterialList(showMessageOK: boolean, showMessageKO: boolean) {
	if (rawMaterialEntries.value.length === 0) return
	var allMaterialsValid = true
	rawMaterialEntries.value.forEach((singleMaterial: RawMaterialTableRow) => {
		var materialValid = false
		switch (props.tabName) {
			case tabsDefinitions.packaging.value:
				if (props.subTabName === subTabsDefinitions.deviceMaterials.value.label) {
					materialValid =
						singleMaterial.materialId !== null &&
						singleMaterial.unitId !== null &&
						singleMaterial.componentName !== undefined &&
						singleMaterial.componentName !== "" &&
						singleMaterial.quantity !== null
				} else {
					materialValid =
						singleMaterial.materialId !== null &&
						singleMaterial.unitId !== null &&
						singleMaterial.componentName !== undefined &&
						singleMaterial.componentName !== "" &&
						singleMaterial.packagingTypeId !== null &&
						singleMaterial.packagingTypeId !== undefined &&
						singleMaterial.quantity !== null
				}
				break
			case tabsDefinitions.distribution.value:
				materialValid = singleMaterial.materialId !== null && singleMaterial.unitId !== null
				break
			default:
				// Check if unit operations column should be shown based on current state
				materialValid =
					(singleMaterial.isIntermediate ? true : singleMaterial.materialId !== null) &&
					singleMaterial.unitId !== null &&
					(singleMaterial.isIntermediate
						? true
						: shouldShowUnitOperationColumn.value
							? singleMaterial.unitOperationId !== undefined && singleMaterial.unitOperationId !== null
							: true)
				break
		}
		// If any material is invalid, mark the whole list as invalid
		if (!materialValid) {
			allMaterialsValid = false
		}
	})

	//check per screen type

	if (!allMaterialsValid) {
		if (showMessageKO)
			toast.add({
				severity: "error",
				summary: "Please fill all required fields in Raw Materials Table",
				detail: ``,
				life: 3000,
				group: props.tabId,
			})
		return false
	} else {
		if (showMessageOK)
			toast.add({
				severity: "success",
				summary: "Raw Materials saved",
				detail: ``,
				life: 3000,
				group: props.tabId,
			})
		selectedRow.value = []
	}
	return true
}
function saveInboundTransportList(showMessageOK: boolean, showMessageKO: boolean) {
	var countError = inboundTransportList.value.filter(
		(el: any) => (el.distance === "" || el.distance === null || el.unitId === null) && el.isEditable && el.modeOfTransportId !== null
	)
	if (countError.length !== 0) {
		if (showMessageKO)
			toast.add({
				severity: "error",
				summary: "Please fill all required fields in Inbound Transport Table",
				detail: ``,
				life: 3000,
				group: props.tabId,
			})
		return false
	} else {
		if (showMessageOK)
			toast.add({
				severity: "success",
				summary: "Inbound Transports saved",
				detail: ``,
				life: 3000,
				group: props.tabId,
			})
	}
	return true
}
//QUALITY SCORE COLOR
function returnStyleDataQualityRatingColor(data: any) {
	if (data === undefined || data === null || data === "" || data == "0") return "background-color: #FFFFFF !important;color:#000000 !important;"
	var getData = qualityRatings.value.find((item: any) => item.dataQualityRatingId === data.toString())
	if (getData !== null)
		return "background-color: " + getData.color + " !important;color: " + (data.toString() !== "1" ? "#FFFFFF" : "#000000") + " !important;"
	else return "background-color: #FFFFFF !important;color: #000000 !important;"
}

//QUALITY SCORE TOOLTIP
function getDataQualityRatingTooltip(score: any) {
	if (score === undefined || score === null || score === "") return ""
	switch (score.toString()) {
		case "1":
			return "High, exact match to background dataset or modelled process"
		case "2":
			return "Medium, based on close proxy or on reaction pathway using either stoichiometric quantities of reagents or a synthetic route (e.g. modelling medium-density polyethylene based on average of high- and low-density polyethylene)"
		case "3":
			return "Low, based on crude proxy or on other assumptions (e.g. modelling organic chemicals based on proxy groupings)"
		default:
			return ""
	}
}

//IMAGE
//open file selector for image
const openFileSelector = () => {
	const fileInputElement = fileUploader.value?.$el.querySelector('input[type="file"]')
	if (fileInputElement) {
		fileInputElement.value = ""
		fileInputElement.click()
	}
}
//when user select image file
const onSelectedFiles = (event: any) => {
	image.value = ""
	deleteTheImage.value = false
	if (event.files.length > 1) event.files.shift()
	//return
	const file = event.files[0]

	if (file) {
		const reader = new FileReader()

		reader.onload = (e) => {
			imageURL.valueL = e.target.result
		}

		reader.readAsDataURL(file)
		actualFile.value = file
		updatedImage.value = true
	}
}
//image basic
function clearImage() {
	actualFile.value = null
	image.value = ""
}

function deleteImage() {
	deleteTheImage.value = true
	clearImage()
}

// UNIT OPERATIONS
//new unit operation actions
//rightclick on unit operations
const menuItems = [
	{ label: "Edit", command: () => performAction("edit") },
	{ label: "Delete", command: () => performAction("delete") },
]
//right click for modify/delete unit operation
const menu = ref<InstanceType<typeof ContextMenu> | null>(null)
function onRightClick(event: any) {
	selectedUnitOperationForDeleteOrModify.value = unitOperations.value.find((item: any) => item.unitOperationName === event.target.innerText)

	if (selectedUnitOperationForDeleteOrModify.value.isNew === true) menu.value.show(event)
}
//menu on right click actions
function performAction(actionType: string) {
	switch (actionType) {
		case "edit":
			addNewUnitOperation.value = true
			unitOperation.id = selectedUnitOperationForDeleteOrModify.value.id
			unitOperation.unitOperationName = selectedUnitOperationForDeleteOrModify.value.unitOperationName
			unitOperation.electricity = selectedUnitOperationForDeleteOrModify.value.electricity
			unitOperation.steam = selectedUnitOperationForDeleteOrModify.value.steam
			unitOperation.loss = selectedUnitOperationForDeleteOrModify.value.loss
			unitOperation.comment = selectedUnitOperationForDeleteOrModify.value.comment
			break
		case "delete":
			apiClient.deleteIfUnitOperationIsNotInUse(selectedUnitOperationForDeleteOrModify.value.id).then((res) => {
				if (res === "used") {
					toast.add({
						severity: "error",
						summary: "You cannot delete used unit Operation!",
						detail: ``,
						life: 3000,
						group: props.tabId,
					})
				} else {
					selectedUnitOperations.value = selectedUnitOperations.value.filter((item: any) => item !== selectedUnitOperationForDeleteOrModify.value.id)
					changeBasicInfo()
					toast.add({
						severity: "success",
						summary: "Deleted",
						detail: ``,
						life: 3000,
						group: props.tabId,
					})
				}
			})
			break
	}
}
function addNewUnitOp() {
	unitOperation = new UnitOperation()
	addNewUnitOperation.value = true
}
//pressed cancel button on mod/add unitoperation
function cancelNewUnitOp() {
	addNewUnitOperation.value = false
}
//save new unitop or update it
function saveNewUnitOp() {
	unitOperation.id = unitOperation.id == null ? self.crypto.randomUUID() : unitOperation.id
	unitOperation.isActive = true
	unitOperation.screenId = props.tabId
	apiClient.putUnitOperation(unitOperation).then((res) => {
		addNewUnitOperation.value = false
		// Make sure isNew is false after saving
		res.isNew = false
		pushIfNotExistUpdateIfExists(res)
	})
}
//update available unit operations if unitoperation is updated/added/deleted
function pushIfNotExistUpdateIfExists(unitOp: UnitOperation) {
	let findIt = unitOperations.value.find((item: any) => item.id === unitOp.id)
	if (findIt === undefined) {
		unitOperations.value.push(unitOp)
		selectableUnitOperations.value.push(unitOp)
		selectedUnitOperations.value.push(unitOp.id)
	} else {
		var idxUnitOp = unitOperations.value.findIndex((item: any) => item.id === unitOp.id)
		unitOperations.value[idxUnitOp] = unitOp
		var idxSelUnitOp = selectableUnitOperations.value.findIndex((item: any) => item.id === unitOp.id)
		selectableUnitOperations.value[idxSelUnitOp] = unitOp
	}
}
//check if unitOp is used in the rawmaterial list
function checkIfUnitOpIsUsedInMaterialTable(unitOpId: string) {
	return rawMaterialEntries.value.some((item: any) => item.unitOperationId === unitOpId)
}
//update unit operation
async function updateFilteringOfUnitOperations(ev: any) {
	const removedItems = actualUnitOperation.value.filter((item) => !ev.value.includes(item))
	const addedItems = ev.value.filter((item: string) => !actualUnitOperation.value.includes(item))

	// Check if any removed item is still in use (only if flag is enabled)
	if (enableCheckIfUnitOperationIsUsed) {
		let hasUsedUnitOperation = false
		for (const item of removedItems) {
			if (checkIfUnitOpIsUsedInMaterialTable(item)) {
				toast.add({
					severity: "warn",
					summary: "Warning",
					detail: `Cannot remove unit operation "${unitOperations.value.find((op: any) => op.id === item).unitOperationName}" because it is used in the materials table.`,
					life: 5000,
				})
				hasUsedUnitOperation = true
				break
			}
		}

		// If a unit operation is in use, restore the original selection
		if (hasUsedUnitOperation) {
			// Force the MultiSelect to update by clearing first, then restoring with nextTick
			const originalSelection = [...actualUnitOperation.value]
			selectedUnitOperations.value = []
			await nextTick()
			selectedUnitOperations.value = originalSelection
			return
		}
	}

	// No need to track added/removed separately anymore
	// The computed properties will handle this by comparing current vs initial state

	changeBasicInfo()
	// Note: selectableUnitOperations will be updated on save, not here
	actualUnitOperation.value = ev.value
}
//upload image
function submitFile(materialId: string): Promise<boolean> {
	return new Promise((resolve, reject) => {
		if (actualFile.value != "") {
			let formData = new FormData()
			formData.append("file", actualFile.value)
			formData.append("materialId", materialId)
			formData.append("toDelete", deleteTheImage.value.toString())
			axios
				.post(import.meta.env.VITE_API_URL?.toString() + "/api/uploadSpecificAssetData", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						authorization: "bearer " + localStorage.getItem("token"),
					},
				})
				.then((response) => {
					deleteTheImage.value = false
					resolve(true)
				})
				.catch((err) => {
					resolve(false)
				})
		} else {
			let formData = new FormData()
			formData.append("file", actualFile.value)
			formData.append("materialId", materialId)
			formData.append("toDelete", deleteTheImage.value.toString())
			axios
				.post(import.meta.env.VITE_API_URL?.toString() + "/api/uploadSpecificAssetData", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						authorization: "bearer " + localStorage.getItem("token"),
					},
				})
				.then((response) => {
					resolve(true)
				})
				.catch((err) => {
					resolve(false)
				})
			resolve(false)
		}
	})
}
//update material basic info
function changeBasicInfo() {
	if (props.tabName === tabsDefinitions.productProcess.value) {
		if (selectedSite.value === siteLocations.value.find((item: any) => item.siteLocationName === "Global").id) {
			apiClient.updatePPGlobalLocation(actualStepId.value, true).then((res) => {})
		} else {
			apiClient.updatePPGlobalLocation(actualStepId.value, false).then((res) => {})
		}
	}
	if (actualRawMaterialId.value === null) return
	//saveRawMaterials(false)
}

//65650
function getMaterialName(data: RawMaterialTableRow) {
	let materialName = ""
	if (data != null && data.materialId != null) {
		let materialId = data.materialId
		if (data.materials != null && data.materials.length > 0) {
			data.materials.forEach((item: Material) => {
				if (item.id == materialId && item.materialName != null) {
					materialName = item.materialName
				}
			})
		}
	}
	return materialName
}
</script>

<style scoped>
.p-tooltip .p-tooltip-text {
	min-width: 400px !important;
	white-space: normal !important;
	word-wrap: break-word;
	padding: 1rem;
}
</style>

<style lang="scss" scoped>
// .custom-tooltip {
// 	min-width: 400px !important;
// 	white-space: normal !important;
// 	word-wrap: break-word;
// 	padding: 1rem;
// }

// .p-datatable .pi-spin {
// 	animation: spin 1s linear infinite !important;
// }
// .p-invalid {
// 	border-color: red !important;
// }
// .custom-background {
// 	background-color: #fcd34d !important;
// }
// ::v-deep(#dtRawMaterialList .p-datatable-wrapper table .p-datatable-tbody) {
// 	.p-selectable-row.p-highlight {
// 		background-color: #fcd34d;
// 	}
// }
// ::v-deep(div#dtRawMaterialList.isModification .p-datatable-wrapper table .p-datatable-tbody) {
// 	.p-selectable-row.p-highlight {
// 		background-color: #fcd34d;
// 	}
// }
// ::v-deep(.editable-cells-table td.p-cell-editing) {
// 	padding-top: 0;
// 	padding-bottom: 0;
// }
// .p-d-flex {
// 	display: flex;
// }

// .p-jc-center {
// 	justify-content: center;
// }

/*.btn-outline {
	background-color: white;
	color: var(--primary);
	border: 2px solid var(--primary);
	padding: 5px 10px;
	font-size: 12px;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.btn-custom:hover {
	background-color: #007bff;
	color: white;
}*/
</style>
